export const languages = {
  en: {
    "main.title": "Welcome To",
    "main.your_rewards": "Your Rewards",
    "main.become_member_title": "Become a member",
    "main.become_member_desc":
      "With more ways to unlock exciting perks, this is your all access pass to exclusive rewards.",
    "main.join_now": "Join Now",
    "main.points_title": "Points",
    "main.points_desc":
      "Earn more Points for different actions, and turn those Points into awesome rewards!",
    "main.ways_to_earn": "Ways to earn",
    "main.ways_to_redeem": "Ways to redeem",
    "main.referrals_title": "Referrals",
    "main.referrals_desc":
      "Give your friends a reward and claim your own when they make a purchase.",
    "main.referrals_button": "Refer your friends",
    "main.your_points": "Your Points",
    "earn.title": "Ways to earn",
    "earn.sign_up": "Signup",
    "earn.birth_day": "Celebrate a birthday",
    "earn.edit_date": "Edit date",
    "earn.order_title": "Place an order",
    "earn.order_desc":
      "{value} {points_currency} for every {currency}{amount_spent} spent",
    "earn.fb_like": "Like on Facebook",
    "earn.fb_share": "Share on Facebook",
    "earn.insta_follow": "Follow on Instagram",
    "earn.twitter_share": "Share on Twitter",
    "earn.twitter_follow": "Follow on Twitter",
    "redeem.title": "Ways to redeem",
    "redeem.redeem_button": "Redeem",
    "redeem.fixed_coupon": "{currency} {value} off coupon",
    "redeem.percentage_coupon": "{value} % off coupon",
    "redeem.shipping": "Free shipping coupon",
    "rewards.fixed_coupon": "{currency} {value} off",
    "rewards.no_rewards": "No rewards yet",
    "rewards.percentage_coupon": "{value} % off",
    "rewards.shipping": "Free shipping",
    "rewards.your_coupons": "Your coupons",
    "birthday.title": "Birthday Reward",
    "birthday.desc":
      "We want to celebrate your birthday! Make sure you let us know at least 30 days in advance — otherwise, you'll have to wait until next year.",
    "birthday.select_title": "Select your birthday",
    "birthday.save_date": "Save date",
    "discount.title": "Discount code",
    "discount.spent_points": "Spent {value} points",
    "discount.desc": "Use this discount code on your next order!",
    "footer.title": "We Reward with Super Rewards.",
    //new tags after update
    "main.already_have_account": "Already have an account?",
    "charity.title": "Charity Points",
    "charity.donate": "Donate points to your favorite charity!",
    "charity.title_ways": "Ways to donate",
    "charity.donating": "You are donating",
    "referral.they_get": "They get",
    "referral.you_get": "You get",
    "rewards.available": "You have {value} rewards available",
    "subscribe.products": "Subscribe products",
    "subscribe.list": "List of all subscriptions",
    "subscribe.points": "Subscriptions Points",
    "rewards.free_product": "Free product",
    "rewards.list_of_products": "List of all products",
    "main.refferral_completed": "referrals completed",
    "main.referrals_desc_loggedin":
      "Share this URL to give your friends the reward {currency} {value} off coupon",
    "main.view": "View",
    "referral.code": "Your referral code",
    "rewards.see_here": "When you redeem your rewards, you’ll see them here",
    "rewards.go_back": "Go Back",

    "discount.off": "off",
    "discount.points_spent": "Points spent",
    "discount.coupon_valid": "Coupon valid for",
    "discount.for": "for",
    "discount.apply_code": "Apply code",
    "discount.coupon_title": "Discount coupon",
    "discount.expiry_date": "Expiry Date",
    "giftcard.balance": "Balance",
    "giftcard.title_gift": "Gift",
    "giftcard.title_card": "Card",
    "giftcard.copy_code": "Copy code",
    "giftcard.copied": "Copied",

    "earn.giftcard_order_desc": "{value} Gift Card for every {value2} spent",
    "birthday.close": "Close",
    "rewards.view_all": "View all rewards",
    "rewards.view_less": "View less rewards",
    //vip tier
    "main.vip_tier_title": "VIP tiers",
    "main.become_vip_member": "Become a VIP member",
    "main.become_vip_member_desc":
      "Your all access pass to exclusive rewards. Reach higher tiers for more exclusive perks.",
    "main.current_tier": "Current Tier",
    "main.current_tier_desc": "Your all access pass to exclusive rewards.",
    "main.current_tier_btn": "View all tiers",
    "main.vip_you_have_to": "You have to",
    "main.vip_place_order": "place order",
    "main.vip_atleast": "atleast",
    "main.vip_more_than": "more than",
    "main.vip_less_than": "less than",
    "main.vip_time": "time",
    "main.vip_spent": "spent",
    "main.on_your_store": "on our store",
    "vip_tier.percentage_discount_title": "Percentage Discount",
    "vip_tier.percentage_discount_desc":
      "A {value}% discount is automatically applicable to all orders",
    "vip_tier.free_shipping_title": "Free Shipping",
    "vip_tier.free_shipping_desc":
      "Free shipping is automatically applicable to all orders",
    // new
    "earn.write_review": "Write a review",
    "earn.leave_google_review": "Leave Google Review",
    "reward.for_all_orders": "For all orders",
    "reward.collection": "collection",
    "vip_tier.rules": "Rules",
    "vip_tier.special_reward": "Special reward",
    "main.join": "Join now for free to start earning",
    "earn.follow_tiktok": "Follow on TikTok",
    "earn.follow_linkedin": "Follow on LinkedIn",
    "earn.connect_line": "Connect on Line",
    // membership program
    "main.membership_program_title": "Membership program",
    "main.membership_program_desc":
      "Unlock your gateway to exclusive rewards with our premium Membership Plans.",
    "main.membership_program_note": "Plan expires in 1 year after purchase.",
    "main.no_membership_plans": "No membership plans added",
    "membership_program.loyalty_multiplier": "Loyalty Multiplier",
    "membership_program.bonus_points": "Bonus Points",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} upon purchasing the plan",
    "membership_program.bonus_giftcard": "Bonus Giftcard",
    "membership_program.bonus_giftcard_desc":
      "{value} worth of giftcard credit upon purchasing the plan",
    "membership_program.percentage_discount_coupon":
      "Percentage Discount Coupon",
    "membership_program.percentage_discount_coupon_desc":
      "{value}% discount coupon applicable to all orders for one year upon purchasing the plan.",
    "membership_program.free_shipping": "Free Shipping",
    "membership_program.free_shipping_desc":
      "Free shipping coupon applicable to all orders for one year upon purchasing the plan.",
    "membership_program.percentage_automatic_discount": "Percentage Discount",
    "membership_program.percentage_automatic_discount_desc":
      "{value}% discount automatically applied to all orders for one year upon purchasing the plan.",
    "membership_program.free_shipping_automatic_discount": "Free Shipping",
    "membership_program.free_shipping_automatic_discount_desc":
      "Free shipping automatically applied to all orders for one year upon purchasing the plan.",
    "membership_program.active_plan": "Active Plan",
    "membership_program.no_plan_benefits": "No benefits added",
    // limited time offer
    "main.limited_time_offer_program_title": "Limited-time offer program",
    "main.limited_time_offer_program_desc":
      "Access exclusive rewards with our Limited-time Offers before they're gone.",
    "earn.order_limit_note_lifetime":
      "Get {points_currency} on first {value} order/s",
    "earn.order_limit_note":
      "Get {points_currency} on first {value1} order/s every {value2} day/s",
    "earn.share_limit_note_lifetime":
      "Get {points_currency} on first {value} share/s",
    "earn.share_limit_note": "Share {value1} time/s in every {value2} day/s",
  },
  fr: {
    "main.title": "Bienvenue sur",
    "main.your_rewards": "Vos récompenses",
    "main.become_member_title": "Devenir membre",
    "main.become_member_desc":
      "Avec plus de façons de débloquer des avantages passionnants, c'est votre pass d'accès complet à des récompenses exclusives.",
    "main.join_now": "S'inscrire maintenant",
    "main.points_title": "Points",
    "main.points_desc":
      "Gagnez plus de points pour différentes actions et transformez ces points en récompenses impressionnantes !",
    "main.ways_to_earn": "Façons de gagner",
    "main.ways_to_redeem": "Façons d'échanger",
    "main.referrals_title": "Parrainages",
    "main.referrals_desc":
      "Offrez une récompense à vos amis et réclamez la vôtre lorsqu'ils font un achat.",
    "main.referrals_button": "Parrainez vos amis",
    "main.your_points": "Vos points",
    "earn.title": "Façons de gagner",
    "earn.sign_up": "Inscrivez-vous",
    "earn.birth_day": "Célébrer un anniversaire",
    "earn.order_title": "Passer une commande",
    "earn.order_desc":
      "{value} {points_currency} pour chaque {currency}{amount_spent} dépensée",
    "earn.fb_like": "J'aime sur Facebook",
    "earn.fb_share": "Partager sur Facebook",
    "earn.insta_follow": "Suivre sur Instagram",
    "earn.twitter_share": "Partager sur Twitter",
    "earn.twitter_follow": "Suivre sur Twitter",
    "earn.edit_date": "Date d'édition",
    "redeem.title": "Façons d'échanger",
    "redeem.fixed_coupon": "{currency} {value} coupon de réduction",
    "redeem.percentage_coupon": "{value} % de réduction sur le coupon",
    "redeem.shipping": "Coupon de livraison gratuite",
    "redeem.redeem_button": "Racheter",
    "rewards.fixed_coupon": "{currency} {value} off",
    "rewards.no_rewards": "Aucune récompense pour le moment",
    "rewards.percentage_coupon": "{value} % de réduction",
    "rewards.shipping": "Livraison gratuite",
    "rewards.your_coupons": "Vos bons de réduction",
    "birthday.title": "Récompense d'anniversaire",
    "birthday.desc":
      "Nous voulons fêter ton anniversaire ! Assurez-vous de nous prévenir au moins 30 jours à l'avance, sinon vous devrez attendre l'année prochaine.",
    "birthday.select_title": "Sélectionnez votre anniversaire",
    "birthday.save_date": "Réservez la date",
    "discount.title": "Code de réduction",
    "discount.spent_points": "Vous avez dépensé {value} points",
    "discount.desc":
      "Utilisez ce code de réduction sur votre prochaine commande !",
    "footer.title": "Nous récompensons avec des super récompenses.",
    //new tags after update
    "main.already_have_account": "Vous avez déjà un compte ?",
    "charity.title": "Points de charité",
    "charity.donate":
      "Donnez des points à votre organisme de bienfaisance préféré !",
    "charity.title_ways": "Façons de faire un don",
    "charity.donating": "Vous faites un don",
    "referral.they_get": "Ils obtiennent",
    "referral.you_get": "Vous obtenez",
    "rewards.available": "Vous avez {value} récompenses disponibles",
    "subscribe.products": "Souscrire des produits",
    "subscribe.list": "Liste de tous les abonnements",
    "subscribe.points": "Points d'abonnement",
    "rewards.free_product": "Produit gratuit",
    "rewards.list_of_products": "Liste de tous les produits",
    "main.refferral_completed": "références terminées",
    "main.referrals_desc_loggedin":
      "Partagez cette URL pour offrir à vos amis la récompense {currency} {value} off coupon",
    "main.view": "Afficher",
    "referral.code": "Votre code de parrainage",
    "rewards.see_here":
      "Lorsque vous échangez vos récompenses, vous les verrez ici",
    "rewards.go_back": "Revenir en arrière",

    "discount.off": "off",
    "discount.points_spent": "Points dépensés",
    "discount.coupon_valid": "Coupon valable pour",
    "discount.for": "pour",
    "discount.apply_code": "Appliquer le code",
    "discount.coupon_title": "Coupon de réduction",
    "discount.expiry_date": "Date d'expiration",
    "giftcard.balance": "Solde",
    "giftcard.title_gift": "Cadeau",
    "giftcard.title_card": "Carte",
    "giftcard.copy_code": "Copier le code",
    "giftcard.copied": "Copié",

    "earn.giftcard_order_desc":
      "{value} Gift Card pour chaque {value2} dépensé",
    "anniversaire.close": "Fermer",
    "rewards.view_all": "Voir toutes les récompenses",
    "rewards.view_less": "Voir moins de récompenses",
    //
    "main.vip_tier_title": "Niveaux VIP",
    "main.become_vip_member": "Devenir membre VIP",
    "main.become_vip_member_desc":
      "Votre pass d'accès complet à des récompenses exclusives. Atteignez des niveaux supérieurs pour des avantages plus exclusifs.",
    "main.current_tier": "Niveau actuel",
    "main.current_tier_desc":
      "Votre pass d'accès complet à des récompenses exclusives.",
    "main.current_tier_btn": "Afficher tous les niveaux",
    "main.vip_you_have_to": "Vous devez",
    "main.vip_place_order": "passer la commande",
    "main.vip_atleast": "au moins",
    "main.vip_more_than": "plus de",
    "main.vip_less_than": "moins que",
    "main.vip_time": "heure",
    "main.vip_spent": "dépensé",
    "main.on_your_store": "sur notre boutique",
    "vip_tier.percentage_discount_title": "Remise en pourcentage",
    "vip_tier.percentage_discount_desc":
      "Appliquer une remise en pourcentage de {value}% à toutes les commandes.",
    "vip_tier.free_shipping_title": "Livraison gratuite",
    "vip_tier.free_shipping_desc":
      "Appliquer la livraison gratuite à toutes les commandes.",

    "earn.write_review": "Écrire un avis",
    "earn.leave_google_review": "Quitter l'avis Google",
    "reward.for_all_orders": "Pour toutes les commandes",
    "récompense.collection": "collection",
    "vip_tier.rules": "Règles",
    "vip_tier.special_reward": "Récompense spéciale",
    "main.join":
      "Inscrivez-vous maintenant gratuitement pour commencer à gagner",
    "earn.follow_tiktok": "Suivre sur TikTok",
    "earn.follow_linkedin": "Suivre sur LinkedIn",
    "earn.connect_line": "Connectez-vous sur Line",
    // membership program
    "main.membership_program_title": "Programme d'adhésion",
    "main.membership_program_desc":
      "Débloquez votre porte d'accès à des récompenses exclusives avec nos plans d'adhésion premium.",
    "main.memebership_program_note": "Le plan expire dans 1 an après l'achat.",
    "main.no_membership_plans": "Aucun plan d'adhésion ajouté",
    "membership_program.loyalty_multiplier": "Multiplicateur de fidélité",
    "membership_program.bonus_points": "Points bonus",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} lors de l'achat du plan",
    "membership_program.bonus_giftcard": "Carte-cadeau bonus",
    "membership_program.bonus_giftcard_desc":
      "Crédit de carte-cadeau d'une valeur de {value} lors de l'achat du plan",
    "membership_program.percentage_discount_coupon":
      "Coupon de réduction en pourcentage",
    "membership_program.percentage_discount_coupon_desc":
      "Coupon de réduction de {value}% applicable à toutes les commandes pendant un an dès l'achat du plan.",
    "membership_program.free_shipping": "Livraison gratuite",
    "membership_program.free_shipping_desc":
      "Coupon de livraison gratuite applicable à toutes les commandes pendant un an dès l'achat du plan.",
    "membership_program.percentage_automatic_discount":
      "Réduction en pourcentage",
    "membership_program.percentage_automatic_discount_desc":
      "Réduction en pourcentage automatique appliquée à toutes les commandes pendant un an dès l'achat du plan.",
    "membership_program.free_shipping_automatic_discount": "Livraison gratuite",
    "membership_program.free_shipping_automatic_discount_desc":
      "Livraison gratuite automatique appliquée à toutes les commandes pendant un an dès l'achat du plan.",
    "membership_program.active_plan": "Plan actif",
    "membership_program.no_plan_benefits": "Aucun avantage ajouté",
    // limited time offer
    "main.limited_time_offer_program_title":
      "Programme d'offre à durée limitée",
    "main.limited_time_offer_program_desc":
      "Accédez aux récompenses exclusives avec nos offres à durée limitée avant qu'elles ne disparaissent.",
    "earn.order_limit_note_lifetime":
      "Obtenez {points_currency} sur les {value} premières commandes",
    "earn.order_limit_note":
      "Obtenez {points_currency} sur les {value1} premières commandes chaque {value2} jour/s",
    "earn.share_limit_note_lifetime":
      "Obtenez {points_currency} sur les {value} premiers partages",
    "earn.share_limit_note": "Partagez {value1} fois chaque {value2} jour/s",
  },
  sp: {
    "main.title": "Bienvenido a",
    "main.your_rewards": "Tus recompensas",
    "main.become_member_title": "Hágase miembro",
    "main.become_member_desc":
      "Con más formas de desbloquear beneficios emocionantes, este es su pase de acceso total a recompensas exclusivas.",
    "main.join_now": "Únete ahora",
    "main.points_title": "Puntos",
    "main.points_desc":
      "¡Gana más puntos por diferentes acciones y convierte esos puntos en increíbles recompensas!",
    "main.ways_to_earn": "Formas de ganar",
    "main.ways_to_redeem": "Formas de canjear",
    "main.referrals_title": "Referencias",
    "main.referrals_desc":
      "Dale a tus amigos una recompensa y reclama la tuya cuando realicen una compra.",
    "main.referrals_button": "Recomienda a sus amigos",
    "main.your_points": "Tus Puntos",
    "earn.title": "Formas de ganar",
    "earn.sign_up": "Registrarse",
    "earn.birth_day": "Celebre un cumpleaños",
    "earn.order_title": "Realizar un pedido",
    "earn.order_desc":
      "{value} {points_currency} por cada {currency}{amount_spent} gastado",
    "earn.fb_like": "Me gusta en Facebook",
    "earn.fb_share": "Compartir en Facebook",
    "earn.insta_follow": "Seguir en Instagram",
    "earn.twitter_share": "Compartir en Twitter",
    "earn.twitter_follow": "Seguir en Twitter",
    "earn.edit_date": "Fecha de edición",
    "redeem.title": "Formas de canjear",
    "redeem.fixed_coupon": "{currency} {value} cupón de descuento",
    "redeem.percentage_coupon": "{value}% de descuento en cupón",
    "redeem.shipping": "Cupón de envío gratis",
    "redeem.redeem_button": "Canjear",
    "rewards.fixed_coupon": "{currency} {value} de descuento",
    "rewards.no_rewards": "Aún no hay recompensas",
    "rewards.percentage_coupon": "{value}% de descuento",
    "rewards.shipping": "Envío gratuito",
    "rewards.your_coupons": "Tus cupones",
    "birthday.title": "Recompensa de cumpleaños",
    "birthday.desc":
      "¡Queremos celebrar tu cumpleaños! Asegúrese de informarnos con al menos 30 días de anticipación; de lo contrario, tendrá que esperar hasta el próximo año.",
    "birthday.select_title": "Seleccione su cumpleaños",
    "birthday.save_date": "Guarde la fecha",
    "discount.title": "Código de descuento",
    "discount.spent_points": "Gastó {value} puntos",
    "discount.desc": "¡Utilice este código de descuento en su próximo pedido!",
    "footer.title": "Premiamos con Súper Recompensas.",
    //new tags after update
    "main.already_have_account": "¿Ya tienes una cuenta?",
    "charity.title": "Puntos de caridad",
    "charity.donate": "¡Dona puntos a tu organización benéfica favorita!",
    "charity.title_ways": "Formas de donar",
    "charity.donating": "Está donando",
    "referral.they_get": "Obtienen",
    "referral.you_get": "Obtienes",
    "rewards.available": "Tienes {value} recompensas disponibles",
    "subscribe.products": "Suscribir productos",
    "subscribe.list": "Lista de todas las suscripciones",
    "subscribe.points": "Puntos de suscripción",
    "rewards.free_product": "Producto gratuito",
    "rewards.list_of_products": "Lista de todos los productos",
    "main.refferral_completed": "referencias completadas",
    "main.referrals_desc_loggedin":
      "Comparte esta URL para darles a tus amigos la recompensa {currency} {value} de descuento en el cupón",
    "main.view": "Ver",
    "referral.code": "Su código de referencia",
    "rewards.see_here": "Cuando canjee sus recompensas, las verá aquí",
    "rewards.go_back": "Regresar",

    "discount.off": "off",
    "discount.points_spent": "Puntos gastados",
    "discount.coupon_valid": "Cupón válido para",
    "discount.for": "para",
    "discount.apply_code": "Aplicar código",
    "discount.coupon_title": "Cupón de descuento",
    "discount.expiry_date": "Fecha de caducidad",
    "giftcard.balance": "Saldo",
    "giftcard.title_gift": "Regalo",
    "giftcard.title_card": "Tarjeta",
    "giftcard.copy_code": "Copiar código",
    "giftcard.copied": "Copiado",

    "earn.giftcard_order_desc":
      "Tarjeta de regalo de {value} por cada {value2} gastado",
    "birthday.close": "Cerrar",
    "rewards.view_all": "Ver todas las recompensas",
    "rewards.view_less": "Ver menos recompensas",
    //
    "main.vip_tier_title": "Niveles VIP",
    "main.become_vip_member": "Conviértete en miembro VIP",
    "main.become_vip_member_desc":
      "Tu pase de acceso completo a recompensas exclusivas. Alcanza niveles más altos para obtener ventajas más exclusivas",
    "main.current_tier": "Nivel actual",
    "main.current_tier_desc":
      "Tu pase de acceso total a recompensas exclusivas.",
    "main.current_tier_btn": "Ver todos los niveles",
    "main.vip_you_have_to": "Tienes que hacerlo",
    "main.vip_place_order": "realizar pedido",
    "main.vip_atleast": "al menos",
    "main.vip_more_than": "más que",
    "main.vip_less_than": "menor que",
    "main.vip_time": "hora",
    "main.vip_spent": "gastado",
    "main.on_your_store": "sur notre boutique",
    "vip_tier.percentage_discount_title": "Remise en pourcentage",
    "vip_tier.percentage_discount_desc":
      "Appliquer une remise en pourcentage de {value}% à toutes les commandes.",
    "vip_tier.free_shipping_title": "Livraison gratuite",
    "vip_tier.free_shipping_desc":
      "Appliquer la livraison gratuite à toutes les commandes.",

    "earn.write_review": "Escribir una reseña",
    "earn.leave_google_review": "Abandonar la revisión de Google",
    "reward.for_all_orders": "Para todos los pedidos",
    "recompensa.colección": "colección",
    "vip_tier.rules": "Reglas",
    "vip_tier.special_reward": "Recompensa especial",
    "main.join": "Únete ahora gratis para empezar a ganar",
    "earn.follow_tiktok": "Seguir en TikTok",
    "earn.follow_linkedin": "Seguir en LinkedIn",
    "earn.connect_line": "Conéctate en Line",
    // membership program
    "main.membership_program_title": "Programa de membresía",
    "main.membership_program_desc":
      "Desbloquea tu acceso a recompensas exclusivas con nuestros planes premium de membresía.",
    "main.membership_program_note":
      "El plan caduca en 1 año después de la compra.",
    "main.no_membership_plans": "No se han agregado planes de membresía",
    "membership_program.loyalty_multiplier": "Multiplicador de lealtad",
    "membership_program.bonus_points": "Puntos de bonificación",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} al comprar el plan",
    "membership_program.bonus_giftcard": "Tarjeta de regalo de bonificación",
    "membership_program.bonus_giftcard_desc":
      "Crédito de tarjeta de regalo por un valor de {value} al comprar el plan",
    "membership_program.percentage_discount_coupon":
      "Cupón de descuento porcentaje",
    "membership_program.percentage_discount_coupon_desc":
      "Cupón de descuento del {value}% aplicable a todos los pedidos durante un año al comprar el plan.",
    "membership_program.free_shipping": "Envío gratuito",
    "membership_program.free_shipping_desc":
      "Cupón de envío gratuito aplicable a todos los pedidos durante un año al comprar el plan.",
    "membership_program.percentage_automatic_discount": "Descuento porcentual",
    "membership_program.percentage_automatic_discount_desc":
      "Descuento porcentual automático aplicado a todos los pedidos durante un año al comprar el plan.",
    "membership_program.free_shipping_automatic_discount": "Envío gratuito",
    "membership_program.free_shipping_automatic_discount_desc":
      "Envío gratuito automático aplicado a todos los pedidos durante un año al comprar el plan.",
    "membership_program.active_plan": "Plan activo",
    "membership_program.no_plan_benefits": "Ningún beneficio añadido",
    // limited time offer
    "main.limited_time_offer_program_title":
      "Programa de oferta por tiempo limitado",
    "main.limited_time_offer_program_desc":
      "Accede a recompensas exclusivas con nuestras ofertas por tiempo limitado antes de que se agoten.",
    "earn.order_limit_note_lifetime":
      "Obtén {points_currency} en las {value} primeras órdenes",
    "earn.order_limit_note":
      "Obtén {points_currency} en las {value1} primeras órdenes cada {value2} día/s",
    "earn.share_limit_note_lifetime":
      "Obtén {points_currency} en las {value} primeras acciones",
    "earn.share_limit_note": "Comparte {value1} veces cada {value2} día/s",
  },
  du: {
    "main.title": "Welkom bij",
    "main.your_rewards": "Uw beloningen",
    "main.become_member_title": "Word lid",
    "main.become_member_desc":
      "Met meer manieren om spannende voordelen te ontgrendelen, is dit je toegangspas tot exclusieve beloningen.",
    "main.join_now": "Nu aanmelden",
    "main.points_title": "Punten",
    "main.points_desc":
      "Verdien meer punten voor verschillende acties en verander die punten in geweldige beloningen!",
    "main.ways_to_earn": "Manieren om te verdienen",
    "main.ways_to_redeem": "Manieren om te verzilveren",
    "main.referrals_title": "Verwijzingen",
    "main.referrals_desc":
      "Geef je vrienden een beloning en claim die van jezelf wanneer ze een aankoop doen.",
    "main.referrals_button": "Verwijs je vrienden door",
    "main.your_points": "Uw punten",
    "earn.title": "Manieren om te verdienen",
    "earn.sign_up": "Aanmelden",
    "earn.birth_day": "Vier een verjaardag",
    "earn.order_title": "Plaats een bestelling",
    "earn.order_desc":
      "{value} {points_currency} voor elke uitgegeven {currency}{amount_spent}",
    "earn.fb_like": "Vind ik leuk op Facebook",
    "earn.fb_share": "Deel op Facebook",
    "earn.insta_follow": "Volg op Instagram",
    "earn.twitter_share": "Deel op Twitter",
    "earn.twitter_follow": "Volg op Twitter",
    "earn.edit_date": "Datum aanpassen",
    "redeem.title": "Manieren om te verzilveren",
    "redeem.fixed_coupon": "{currency} {value} kortingsbon",
    "redeem.percentage_coupon": "{value} % kortingsbon",
    "redeem.verzending": "Coupon voor gratis verzending",
    "redeem.redeem_button": "Inwisselen",
    "rewards.fixed_coupon": "{valuta} {waarde} korting",
    "rewards.no_rewards": "Nog geen beloningen",
    "rewards.percentage_coupon": "{value} % korting",
    "rewards.shipping": "Gratis verzending",
    "rewards.your_coupons": "uw bonnen",
    "birthday.title": "Verjaardagsbeloning",
    "birthday.desc":
      "We willen je verjaardag vieren! Zorg ervoor dat u ons dit minimaal 30 dagen van tevoren laat weten, anders moet u wachten tot volgend jaar.",
    "birthday.select_title": "Selecteer je verjaardag",
    "birthday.save_date": "Bewaar datum",
    "discount.title": "Kortingscode",
    "discount.spent_points": "{value} punten besteed",
    "discount.desc": "Gebruik deze kortingscode bij je volgende bestelling!",
    "footer.title": "We belonen met Super Rewards.",
    //new tags after update
    "main.already_have_account": "Heb je al een account?",
    "charity.title": "Goede doelen",
    "charity.donate": "Doneer punten aan je favoriete goede doel!",
    "charity.title_ways": "Manieren om te doneren",
    "charity.donating": "U doneert",
    "referral.they_get": "Ze krijgen",
    "referral.you_get": "Je krijgt",
    "rewards.available": "Je hebt {value} rewards beschikbaar",
    "subscribe.products": "Abonneer producten",
    "subscribe.list": "Lijst van alle abonnementen",
    "subscribe.points": "Abonnementspunten",
    "rewards.free_product": "Gratis product",
    "rewards.list_of_products": "Lijst van alle producten",
    "main.refferral_completed": "verwijzingen voltooid",
    "main.referrals_desc_loggedin":
      "Deel deze URL om je vrienden de beloning {currency} {value} kortingsbon te geven",
    "main.view": "Bekijken",
    "referral.code": "Uw verwijzingscode",
    "rewards.see_here": "Wanneer u uw beloningen inwisselt, ziet u ze hier",
    "rewards.go_back": "Ga terug",

    "discount.off": "uit",
    "discount.points_spent": "Punten besteed",
    "discount.coupon_valid": "Coupon geldig voor",
    "discount.for": "voor",
    "discount.apply_code": "Code toepassen",
    "discount.coupon_title": "Kortingsbon",
    "discount.expiry_date": "Vervaldatum",
    "giftcard.balance": "Saldo",
    "giftcard.title_gift": "Cadeau",
    "giftcard.title_card": "Kaart",
    "giftcard.copy_code": "Code kopiëren",
    "giftcard.copied": "Gekopieerd",

    "earn.giftcard_order_desc":
      "{value} Gift Card voor elke uitgegeven {value2}",
    "verjaardag.close": "Close",
    "rewards.view_all": "Bekijk alle beloningen",
    "rewards.view_less": "Bekijk minder beloningen",
    //
    "main.vip_tier_title": "VIP-niveaus",
    "main.become_vip_member": "Word een VIP-lid",
    "main.become_vip_member_desc":
      "Uw toegangspas voor exclusieve beloningen. Bereik hogere niveaus voor meer exclusieve voordelen.",
    "main.current_tier": "Huidige laag",
    "main.current_tier_desc": "Uw toegangspas voor exclusieve beloningen.",
    "main.current_tier_btn": "Bekijk alle niveaus",
    "main.vip_you_have_to": "Je moet",
    "main.vip_place_order": "plaats bestelling",
    "main.vip_atleast": "ten minste",
    "main.vip_more_than": "meer dan",
    "main.vip_less_than": "minder dan",
    "main.vip_time": "tijd",
    "main.vip_spent": "uitgegeven",
    "main.on_your_store": "in onze winkel",
    "vip_tier.percentage_discount_title": "Percentage Discount",
    "vip_tier.percentage_discount_desc":
      "Automatically apply a {value}% discount to all orders.",
    "vip_tier.free_shipping_title": "Free Shipping",
    "vip_tier.free_shipping_desc":
      "Automatically apply free shipping to all orders.",

    "earn.write_review": "Schrijf een recensie",
    "earn.leave_google_review": "Google Review verlaten",
    "reward.for_all_orders": "Voor alle bestellingen",
    "reward.collection": "collection",
    "vip_tier.rules": "Regels",
    "vip_tier.special_reward": "Speciale beloning",
    "main.join": "Word nu gratis lid om geld te verdienen",
    "earn.follow_tiktok": "Volg op TikTok",
    "earn.follow_linkedin": "Volg op LinkedIn",
    "earn.connect_line": "Verbinden op Line",
    // membership program
    "main.membership_program_title": "Lidmaatschapsprogramma",
    "main.membership_program_desc":
      "Ontgrendel je toegangspoort tot exclusieve beloningen met onze premium lidmaatschapsplannen.",
    "main.membership_program_note": "Plan verloopt na 1 jaar na aankoop.",
    "main.no_membership_plans": "Geen lidmaatschapsplannen toegevoegd",
    "membership_program.loyalty_multiplier": "Loyaliteitsvermenigvuldiger",
    "membership_program.bonus_points": "Bonuspunten",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} bij aankoop van het plan",
    "membership_program.bonus_giftcard": "Bonus cadeaubon",
    "membership_program.bonus_giftcard_desc":
      "{value} aan giftcard-tegoed bij aankoop van het plan",
    "membership_program.percentage_discount_coupon":
      "Percentage Kortingscoupon",
    "membership_program.percentage_discount_coupon_desc":
      "Kortingscoupon van {value}% geldig op alle bestellingen gedurende één jaar bij aankoop van het plan.",
    "membership_program.free_shipping": "Gratis verzending",
    "membership_program.free_shipping_desc":
      "Gratis verzendingscoupon geldig op alle bestellingen gedurende één jaar bij aankoop van het plan.",
    "membership_program.percentage_automatic_discount": "Percentage Korting",
    "membership_program.percentage_automatic_discount_desc":
      "Percentage Korting automatisch toegepast op alle bestellingen gedurende één jaar bij aankoop van het plan.",
    "membership_program.free_shipping_automatic_discount": "Gratis verzending",
    "membership_program.free_shipping_automatic_discount_desc":
      "Gratis verzendingscoupon automatisch toegepast op alle bestellingen gedurende één jaar bij aankoop van het plan.",
    "membership_program.active_plan": "Actief plan",
    "membership_program.no_plan_benefits": "Geen voordelen toegevoegd",
    // limited time offer
    "main.limited_time_offer_program_title":
      "Programma voor tijdelijke aanbiedingen",
    "main.limited_time_offer_program_desc":
      "Toegang tot exclusieve beloningen met onze tijdelijke aanbiedingen voordat ze verdwenen zijn.",
    "earn.order_limit_note_lifetime":
      "Krijg {points_currency} op de eerste {value} bestellingen",
    "earn.order_limit_note":
      "Krijg {points_currency} op de eerste {value1} bestellingen elke {value2} dag(en)",
    "earn.share_limit_note_lifetime":
      "Krijg {points_currency} op de eerste {value} shares",
    "earn.share_limit_note": "Deel {value1} keer elke {value2} dag(en)",
  },
  // portuguese language
  pr: {
    "main.title": "Bem-vindo ao",
    "main.your_rewards": "Suas recompensas",
    "main.become_member_title": "Torne-se um membro",
    "main.become_member_desc":
      "Com mais maneiras de desbloquear vantagens emocionantes, este é o seu passe de acesso total a recompensas exclusivas.",
    "main.join_now": "Inscreva-se agora",
    "main.points_title": "Pontos",
    "main.points_desc":
      "Ganhe mais pontos por diferentes ações e transforme esses pontos em recompensas incríveis!",
    "main.ways_to_earn": "Maneiras de ganhar",
    "main.ways_to_redeem": "Maneiras de resgatar",
    "main.referrals_title": "Referências",
    "main.referrals_desc":
      "Dê a seus amigos uma recompensa e reivindique a sua quando eles fizerem uma compra.",
    "main.referrals_button": "Indique seus amigos",
    "main.your_points": "Seus pontos",
    "earn.title": "maneiras de ganhar",
    "earn.sign_up": "Inscrição",
    "earn.birth_day": "Comemore um aniversário",
    "earn.order_title": "Faça um pedido",
    "earn.order_desc":
      "{value} {points_currency} para cada {currency}{amount_spent} gasto",
    "ganhar.fb_like": "Curtir no Facebook",
    "earn.fb_share": "Compartilhar no Facebook",
    "earn.insta_follow": "Seguir no Instagram",
    "earn.twitter_share": "Compartilhar no Twitter",
    "earn.twitter_follow": "Seguir no Twitter",
    "earn.edit_date": "Editar data",
    "redeem.title": "Maneiras de resgatar",
    "redeem.fixed_coupon": "{moeda} {valor} desconto no cupom",
    "redeem.percentage_coupon": "cupom de {value}% de desconto",
    "redeem.shipping": "cupom de frete grátis",
    "redeem.redeem_button": "Resgatar",
    "rewards.fixed_coupon": "{moeda} {valor} de desconto",
    "rewards.no_rewards": "Sem recompensas ainda",
    "rewards.percentage_coupon": "{value}% de desconto",
    "rewards.shipping": "Frete grátis",
    "rewards.your_coupons": "Seus cupons",
    "birthday.title": "Recompensa de aniversário",
    "birthday.desc":
      "Queremos comemorar seu aniversário! Avise-nos com pelo menos 30 dias de antecedência - caso contrário, você terá que esperar até o próximo ano .",
    "birthday.select_title": "Selecione seu aniversário",
    "birthday.save_date": "Selecione seu aniversário",
    "discount.title": "Selecione seu aniversário",
    "discount.spent_points": "Gastou {value} pontos",
    "discount.desc": "Use este código de desconto em seu próximo pedido!",
    "footer.title": "Nós recompensamos com Super Recompensas.",
    //new tags after update
    "main.already_have_account": "Já tem uma conta?",
    "charity.title": "Pontos de caridade",
    "charity.donate": "Doe pontos para sua instituição de caridade favorita!",
    "charity.title_ways": "Formas de doar",
    "charity.donating": "Você está doando",
    "referral.they_get": "Eles pegam",
    "referral.you_get": "Você consegue",
    "rewards.available": "Você tem {value} recompensas disponíveis",
    "subscribe.products": "Subscrever produtos",
    "subscribe.list": "Lista de todas as assinaturas",
    "subscribe.points": "Subscriptions Points",
    "rewards.free_product": "Produto grátis",
    "rewards.list_of_products": "Lista de todos os produtos",
    "main.refferral_completed": "referências concluídas",
    "main.referrals_desc_loggedin":
      "Compartilhe este URL para dar a seus amigos o cupom de desconto de {currency} {value}",
    "main.view": "View",
    "referral.code": "Seu código de referência",
    "rewards.see_here":
      "Quando você resgatar suas recompensas, você as verá aqui",
    "rewards.go_back": "Voltar",

    "discount.off": "off",
    "discount.points_spent": "Pontos gastos",
    "discount.coupon_valid": "Cupom válido para",
    "discount.for": "para",
    "discount.apply_code": "Aplicar código",
    "discount.coupon_title": "Cupom de desconto",
    "discount.expiry_date": "Data de validade",
    "giftcard.balance": "Saldo",
    "giftcard.title_gift": "Presente",
    "giftcard.title_card": "Cartão",
    "giftcard.copy_code": "Copiar código",
    "giftcard.copied": "Copiado",

    "earn.giftcard_order_desc":
      "Vale-presente {value} para cada {value2} gasto",
    "birthday.close": "Fechar",
    "rewards.view_all": "Ver todas as recompensas",
    "rewards.view_less": "Ver menos recompensas",
    //
    "main.vip_tier_title": "Níveis VIP",
    "main.become_vip_member": "Torne-se um membro VIP",
    "main.become_vip_member_desc":
      "Seu acesso total a recompensas exclusivas. Alcance níveis mais altos para obter mais vantagens exclusivas.",
    "main.current_tier": "Nível Atual",
    "main.current_tier_desc": "Seu acesso total a recompensas exclusivas.",
    "main.current_tier_btn": "Ver todas as camadas",
    "main.vip_you_have_to": "Você tem que",
    "main.vip_place_order": "fazer pedido",
    "main.vip_atleast": "atleast",
    "main.vip_more_than": "mais que",
    "main.vip_less_than": "menor que",
    "main.vip_time": "hora",
    "main.vip_spent": "gasto",
    "main.on_your_store": "em nossa loja",
    "vip_tier.percentage_discount_title": "Remise en pourcentage",
    "vip_tier.percentage_discount_desc":
      "Appliquer une remise en pourcentage de {value}% à toutes les commandes.",
    "vip_tier.free_shipping_title": "Livraison gratuite",
    "vip_tier.free_shipping_desc":
      "Appliquer la livraison gratuite à toutes les commandes.",

    "earn.write_review": "Escreva um comentário",
    "earn.leave_google_review": "Sair do Google Review",
    "reward.for_all_orders": "Para todos os pedidos",
    "reward.collection": "coleção",
    "vip_tier.rules": "Regras",
    "vip_tier.special_reward": "Recompensa especial",
    "main.join": "Cadastre-se agora gratuitamente para começar a ganhar",
    "earn.follow_tiktok": "Siga no TikTok",
    "earn.follow_linkedin": "Siga no LinkedIn",
    "earn.connect_line": "Conectar-se no Line",
    // membership program
    "main.membership_program_title": "Programa de associação",
    "main.membership_program_desc":
      "Desbloqueie sua passagem para recompensas exclusivas com nossos planos premium de associação.",
    "main.membership_program_note": "O plano expira em 1 ano após a compra.",
    "main.no_membership_plans": "Nenhum plano de associação adicionado",
    "membership_program.loyalty_multiplier": "Multiplicador de lealdade",
    "membership_program.bonus_points": "Pontos de bônus",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} ao comprar o plano",
    "membership_program.bonus_giftcard": "Cartão presente de bônus",
    "membership_program.bonus_giftcard_desc":
      "Crédito de cartão presente no valor de {value} ao comprar o plano",
    "membership_program.percentage_discount_coupon":
      "Cupom de desconto em percentagem",
    "membership_program.percentage_discount_coupon_desc":
      "Cupom de desconto de {value}% aplicável a todos os pedidos por um ano após a compra do plano.",
    "membership_program.free_shipping": "Frete grátis",
    "membership_program.free_shipping_desc":
      "Cupom de frete grátis aplicável a todos os pedidos por um ano após a compra do plano.",
    "membership_program.percentage_automatic_discount": "Desconto porcentual",
    "membership_program.percentage_automatic_discount_desc":
      "Desconto porcentual automaticamente aplicado a todos os pedidos por um ano após a compra do plano.",
    "membership_program.free_shipping_automatic_discount": "Frete grátis",
    "membership_program.free_shipping_automatic_discount_desc":
      "Cupom de frete grátis automaticamente aplicado a todos os pedidos por um ano após a compra do plano.",
    "membership_program.active_plan": "Plano ativo",
    "membership_program.no_plan_benefits": "Nenhum benefício adicionado",
    // limited time offer
    "main.limited_time_offer_program_title":
      "Programa de oferta por tempo limitado",
    "main.limited_time_offer_program_desc":
      "Acesse recompensas exclusivas com nossas Ofertas por tempo limitado antes que elas acabem.",
    "earn.order_limit_note_lifetime":
      "Obtenha {points_currency} nas {value} primeiras encomendas",
    "earn.order_limit_note":
      "Obtenha {points_currency} nas {value1} primeiras encomendas a cada {value2} dia(s)",
    "earn.share_limit_note_lifetime":
      "Obtenha {points_currency} nas {value} primeiras ações",
    "earn.share_limit_note":
      "Compartilhe {value1} vezes a cada {value2} dia(s)",
  },
  indo: {
    "main.title": "Selamat Datang di",
    "main.your_rewards": "Hadiah Anda",
    "main.become_member_title": "Menjadi anggota",
    "main.become_member_desc":
      "Dengan lebih banyak cara untuk membuka keuntungan menarik, ini adalah semua akses Anda ke hadiah eksklusif.",
    "main.join_now": "Gabung Sekarang",
    "main.points_title": "Poin",
    "main.points_desc":
      "Dapatkan lebih banyak Poin untuk berbagai tindakan, dan ubah Poin tersebut menjadi hadiah yang luar biasa!",
    "main.ways_to_earn": "Cara menghasilkan",
    "main.ways_to_redeem": "Cara menebus",
    "main.referrals_title": "Referensi",
    "main.referrals_desc":
      "Berikan teman Anda hadiah dan klaim hadiah Anda sendiri saat mereka melakukan pembelian.",
    "main.referrals_button": "Referensikan teman Anda",
    "main.your_points": "Poin Anda",
    "earn.title": "Cara menghasilkan",
    "earn.sign_up": "Daftar",
    "earn.birth_day": "Merayakan ulang tahun",
    "earn.order_title": "Pesan",
    "earn.order_desc":
      "{value} {points_currency} untuk setiap {currency}{amount_spent} yang dibelanjakan",
    "earn.fb_like": "Suka di Facebook",
    "earn.fb_share": "Bagikan di Facebook",
    "earn.insta_follow": "Ikuti di Instagram",
    "earn.twitter_share": "Bagikan di Twitter",
    "earn.twitter_follow": "Ikuti di Twitter",
    "earn.edit_date": "Mengubah tanggal",
    "redeem.title": "Cara menebus",
    "redeem.fixed_coupon": "kupon diskon {currency} {value}",
    "redeem.percentage_coupon": "kupon diskon {value} %",
    "redeem.shipping": "Kupon pengiriman gratis",
    "redeem.redeem_button": "Menukarkan",
    "rewards.fixed_coupon": "diskon {currency} {value}",
    "rewards.no_rewards": "Belum ada hadiah",
    "rewards.percentage_coupon": "{value} % off",
    "rewards.shipping": "Gratis ongkos kirim",
    "rewards.your_coupons": "Kupon Anda",
    "birthday.title": "Hadiah Ulang Tahun",
    "birthday.desc":
      "Kami ingin merayakan ulang tahun Anda! Pastikan Anda memberi tahu kami setidaknya 30 hari sebelumnya — jika tidak, Anda harus menunggu hingga tahun depan.",
    "birthday.select_title": "Pilih tanggal lahir Anda",
    "birthday.save_date": "Simpan tanggal",
    "discount.title": "Kode diskon",
    "discount.spent_points": "Menghabiskan {value} poin",
    "discount.desc": "Gunakan kode diskon ini untuk pesanan Anda berikutnya!",
    "footer.title": "Kami Menghadiahi dengan Hadiah Super.",
    //new tags after update
    "main.already_have_account": "Sudah punya akun?",
    "charity.title": "Poin Amal",
    "charity.donate": "Sumbangkan poin ke badan amal favorit Anda!",
    "charity.title_ways": "Cara berdonasi",
    "charity.donating": "Anda menyumbang",
    "referral.they_get": "Mereka mendapatkan",
    "referral.you_get": "Anda mendapatkan",
    "rewards.available": "Anda memiliki {value} reward yang tersedia",
    "subscribe.products": "Berlangganan produk",
    "subscribe.list": "Daftar semua langganan",
    "subscribe.points": "Poin Langganan",
    "rewards.free_product": "Produk gratis",
    "rewards.list_of_products": "Daftar semua produk",
    "main.refferral_completed": "rujukan selesai",
    "main.referrals_desc_loggedin":
      "Bagikan URL ini untuk memberi teman Anda kupon diskon {currency} {value}",
    "main.view": "Tampilan",
    "referral.code": "Kode referral Anda",
    "rewards.see_here":
      "Saat Anda menukarkan hadiah, Anda akan melihatnya di sini",
    "rewards.go_back": "Kembali",

    "discount.off": "nonaktif",
    "discount.points_spent": "Poin yang dihabiskan",
    "discount.coupon_valid": "Kupon berlaku untuk",
    "discount.for": "untuk",
    "discount.apply_code": "Terapkan kode",
    "discount.coupon_title": "Kupon diskon",
    "discount.expiry_date": "Tanggal kadaluarsa",
    "giftcard.balance": "Saldo",
    "giftcard.title_gift": "Hadiah",
    "giftcard.title_card": "Kartu",
    "giftcard.copy_code": "Salin kode",
    "giftcard.copied": "Disalin",

    "earn.giftcard_order_desc":
      "{value} Gift Card untuk setiap {value2} yang dibelanjakan",
    "birthday.close": "Tutup",
    "rewards.view_all": "Lihat semua hadiah",
    "rewards.view_less": "Lihat lebih sedikit hadiah",
    //
    "main.vip_tier_title": "Tingkat VIP",
    "main.become_vip_member": "Menjadi anggota VIP",
    "main.become_vip_member_desc":
      "Semua akses Anda untuk mendapatkan hadiah eksklusif. Raih tingkat yang lebih tinggi untuk keuntungan yang lebih eksklusif.",
    "main.current_tier": "Tingkat Saat Ini",
    "main.current_tier_desc": "Semua akses Anda masuk ke hadiah eksklusif.",
    "main.current_tier_btn": "Lihat semua tingkatan",
    "main.vip_you_have_to": "Anda harus",
    "main.vip_place_order": "pesan",
    "main.vip_atleast": "minimal",
    "main.vip_more_than": "lebih dari",
    "main.vip_less_than": "kurang dari",
    "main.vip_time": "waktu",
    "main.vip_spent": "menghabiskan",
    "main.on_your_store": "di toko kami",
    "vip_tier.percentage_discount_title": "Remise en pourcentage",
    "vip_tier.percentage_discount_desc":
      "Appliquer une remise en pourcentage de {value}% à toutes les commandes.",
    "vip_tier.free_shipping_title": "Livraison gratuite",
    "vip_tier.free_shipping_desc":
      "Appliquer la livraison gratuite à toutes les commandes.",

    "earn.write_review": "Tulis ulasan",
    "earn.leave_google_review": "Keluar dari Google Review",
    "reward.for_all_orders": "Untuk semua pesanan",
    "reward.collection": "koleksi",
    "vip_tier.rules": "Aturan",
    "vip_tier.special_reward": "Hadiah khusus",
    "main.join": "Gabung sekarang gratis untuk mulai menghasilkan",
    "earn.follow_tiktok": "Ikuti di TikTok",
    "earn.follow_linkedin": "Ikuti LinkedIn",
    "earn.connect_line": "Terhubung di Line",
    // membership program
    "main.membership_program_title": "Program Keanggotaan",
    "main.membership_program_desc":
      "Buka pintu gerbang menuju hadiah eksklusif dengan Paket Keanggotaan premium kami.",
    "main.membership_program_note":
      "Paket berakhir dalam 1 tahun setelah pembelian.",
    "main.no_membership_plans":
      "Tidak ada rencana keanggotaan yang ditambahkan",
    "membership_program.loyalty_multiplier": "Pengganda Kesetiaan",
    "membership_program.bonus_points": "Poin Bonus",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} saat membeli paket",
    "membership_program.bonus_giftcard": "Kartu Hadiah Bonus",
    "membership_program.bonus_giftcard_desc":
      "Kredit kartu hadiah senilai {value} saat membeli paket",
    "membership_program.percentage_discount_coupon": "Kupon Diskon Persentase",
    "membership_program.percentage_discount_coupon_desc":
      "Kupon diskon sebesar {value}% berlaku untuk semua pesanan selama satu tahun setelah pembelian paket.",
    "membership_program.free_shipping": "Pengiriman Gratis",
    "membership_program.free_shipping_desc":
      "Kupon pengiriman gratis berlaku untuk semua pesanan selama satu tahun setelah pembelian paket.",
    "membership_program.percentage_automatic_discount": "Diskon Persentase",
    "membership_program.percentage_automatic_discount_desc":
      "Diskon persentase otomatis diterapkan untuk semua pesanan selama satu tahun setelah pembelian paket.",
    "membership_program.free_shipping_automatic_discount": "Pengiriman Gratis",
    "membership_program.free_shipping_automatic_discount_desc":
      "Kupon pengiriman gratis otomatis diterapkan untuk semua pesanan selama satu tahun setelah pembelian paket.",
    "membership_program.active_plan": "Rencana Aktif",
    "membership_program.no_plan_benefits": "Tidak ada manfaat yang ditambahkan",
    // limited time offer
    "main.limited_time_offer_program_title": "Program penawaran terbatas waktu",
    "main.limited_time_offer_program_desc":
      "Akses hadiah eksklusif dengan Penawaran Terbatas Waktu kami sebelum mereka hilang.",
    "earn.order_limit_note_lifetime":
      "Dapatkan {points_currency} pada {value} pesanan pertama",
    "earn.order_limit_note":
      "Dapatkan {points_currency} pada {value1} pesanan pertama setiap {value2} hari",
    "earn.share_limit_note_lifetime":
      "Dapatkan {points_currency} pada {value} tindakan pertama",
    "earn.share_limit_note": "Bagikan {value1} kali setiap {value2} hari",
  },
  //german
  gr: {
    "main.title": "Willkommen bei",
    "main.your_rewards": "Deine Belohnungen",
    "main.become_member_title": "Mitglied werden",
    "main.become_member_desc":
      "Mit noch mehr Möglichkeiten, aufregende Vorteile freizuschalten, ist dies dein All-Access-Pass für exklusive Belohnungen.",
    "main.join_now": "Jetzt beitreten",
    "main.points_title": "Punkte",
    "main.points_desc":
      "Verdiene mehr Punkte für verschiedene Aktionen und verwandle diese Punkte in tolle Belohnungen!",
    "main.ways_to_earn": "Möglichkeiten zu verdienen",
    "main.ways_to_redeem": "Möglichkeiten zum Einlösen",
    "main.referrals_title": "Empfehlungen",
    "main.referrals_desc":
      "Gib deinen Freunden eine Belohnung und beanspruche deine eigene, wenn sie einen Kauf tätigen.",
    "main.referrals_button": "Empfehle deine Freunde",
    "main.your_points": "Ihre Punkte",
    "earn.title": "Möglichkeiten zum Verdienen",
    "earn.sign_up": "Anmelden",
    "earn.birth_day": "Feiern Sie einen Geburtstag",
    "earn.order_title": "Bestellung aufgeben",
    "earn.order_desc":
      "{value} {points_currency} für jeden ausgegebenen {currency}{amount_spent}",
    "earn.fb_like": "Gefällt mir auf Facebook",
    "earn.fb_share": "Auf Facebook teilen",
    "earn.insta_follow": "Folge auf Instagram",
    "earn.twitter_share": "Auf Twitter teilen",
    "earn.twitter_follow": "Folge auf Twitter",
    "earn.edit_date": "Datum bearbeiten",
    "redeem.title": "Möglichkeiten zum Einlösen",
    "redeem.fixed_coupon": "{currency} {value} Rabatt-Gutschein",
    "redeem.percentage_coupon": "{value} % Rabatt auf den Coupon",
    "redeem.Versand": "Kostenloser Versandgutschein",
    "redeem.redeem_button": "Tilgen",
    "rewards.fixed_coupon": "{currency} {value} off",
    "rewards.no_rewards": "Noch keine Belohnungen",
    "rewards.percentage_coupon": "{value} % Rabatt",
    "rewards.Versand": "Kostenloser Versand",
    "rewards.your_coupons": "Ihre Gutscheine",
    "birthday.title": "Geburtstagsbelohnung",
    "birthday.desc":
      "Wir wollen deinen Geburtstag feiern! Geben Sie uns mindestens 30 Tage im Voraus Bescheid – andernfalls müssen Sie bis zum nächsten Jahr warten.",
    "birthday.select_title": "Wählen Sie Ihren Geburtstag aus",
    "birthday.save_date": "Sichere Termin",
    "discount.title": "Rabattcode",
    "discount.spent_points": "{value} Punkte ausgegeben",
    "discount.desc":
      "Verwenden Sie diesen Rabattcode bei Ihrer nächsten Bestellung!",
    "footer.title": "Wir belohnen mit Super Rewards.",
    //new tags after update
    "main.already_have_account": "Haben Sie bereits ein Konto?",
    "charity.title": "Wohltätigkeitspunkte",
    "charity.donate":
      "Spenden Sie Punkte an Ihre Lieblings-Wohltätigkeitsorganisation!",
    "charity.title_ways": "Möglichkeiten zu spenden",
    "charity.donating": "Sie spenden",
    "referral.they_get": "Sie bekommen",
    "referral.you_get": "Sie bekommen",
    "rewards.available": "Sie haben {value} Prämien verfügbar",
    "subscribe.products": "Produkte abonnieren",
    "subscribe.list": "Liste aller Abonnements",
    "subscribe.points": "Abonnement-Punkte",
    "rewards.free_product": "Kostenloses Produkt",
    "rewards.list_of_products": "Liste aller Produkte",
    "main.refferral_completed": "Empfehlungen abgeschlossen",
    "main.referrals_desc_loggedin":
      "Teilen Sie diese URL, um Ihren Freunden die Belohnung {currency} {value} Rabattcoupon zu geben",
    "main.view": "Ansicht",
    "referral.code": "Ihr Empfehlungscode",
    "rewards.see_here":
      "Wenn Sie Ihre Belohnungen einlösen, werden sie hier angezeigt",
    "rewards.go_back": "Zurück gehen",

    "discount.off": "aus",
    "discount.points_spent": "Ausgegebene Punkte",
    "discount.coupon_valid": "Gutschein gültig für",
    "discount.for": "für",
    "discount.apply_code": "Code anwenden",
    "discount.coupon_title": "Rabattgutschein",
    "discount.expiry_date": "Verfallsdatum",
    "giftcard.balance": "Guthaben",
    "giftcard.title_gift": "Geschenk",
    "giftcard.title_card": "Karte",
    "giftcard.copy_code": "Code kopieren",
    "giftcard.copied": "Kopiert",

    "earn.giftcard_order_desc":
      "{value} Geschenkkarte für jeden ausgegebenen {value2}",
    "birthday.close": "Schließen",
    "rewards.view_all": "Alle Belohnungen anzeigen",
    "rewards.view_less": "Weniger Belohnungen anzeigen",
    //
    "main.vip_tier_title": "VIP-Stufen",
    "main.become_vip_member": "VIP-Mitglied werden",
    "main.become_vip_member_desc":
      "Ihr All-Access-Pass zu exklusiven Belohnungen. Erreichen Sie höhere Stufen für exklusivere Vorteile.",
    "main.current_tier": "Aktuelle Stufe",
    "main.current_tier_desc": "Ihr Zugangspass zu exklusiven Prämien.",
    "main.current_tier_btn": "Alle Stufen anzeigen",
    "main.vip_you_have_to": "Du musst",
    "main.vip_place_order": "Bestellung aufgeben",
    "main.vip_atleast": "mindestens",
    "main.vip_more_than": "mehr als",
    "main.vip_less_than": "weniger als",
    "main.vip_time": "Zeit",
    "main.vip_spent": "ausgegeben",
    "main.on_your_store": "in unserem Shop",
    "vip_tier.percentage_discount_title": "Prozentrabatt",
    "vip_tier.percentage_discount_desc":
      "Automatisch {value}% Rabatt auf alle Bestellungen anwenden.",
    "vip_tier.free_shipping_title": "Kostenloser Versand",
    "vip_tier.free_shipping_desc":
      "Automatisch kostenloser Versand auf alle Bestellungen anwenden.",

    "earn.write_review": "Eine Rezension schreiben",
    "earn.leave_google_review": "Google Bewertung hinterlassen",
    "reward.for_all_orders": "Für alle Bestellungen",
    "reward.collection": "Sammlung",
    "vip_tier.rules": "Regeln",
    "vip_tier.special_reward": "Sonderbelohnung",
    "main.join": "Jetzt kostenlos beitreten, um mit dem Verdienen zu beginnen",
    "earn.follow_tiktok": "Auf TikTok folgen",
    "earn.follow_linkedin": "Auf LinkedIn folgen",
    "earn.connect_line": "Verbinden Sie sich auf Line",
    // membership program
    "main.membership_program_title": "Mitgliedschaftsprogramm",
    "main.membership_program_desc":
      "Entsperren Sie Ihren Zugang zu exklusiven Belohnungen mit unseren Premium-Mitgliedschaftsplänen.",
    "main.membership_program_note": "Plan läuft 1 Jahr nach dem Kauf ab.",
    "main.no_membership_plans": "Keine Mitgliedschaftspläne hinzugefügt",
    "membership_program.loyalty_multiplier": "Treue-Multiplikator",
    "membership_program.bonus_points": "Bonuspunkte",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} beim Kauf des Plans",
    "membership_program.bonus_giftcard": "Bonus-Geschenkkarte",
    "membership_program.bonus_giftcard_desc":
      "{value} Guthaben auf der Geschenkkarte beim Kauf des Plans",
    "membership_program.percentage_discount_coupon": "Prozentrabatt-Gutschein",
    "membership_program.percentage_discount_coupon_desc":
      "{value}% Rabattgutschein, der für alle Bestellungen für ein Jahr ab Kauf des Plans gilt.",
    "membership_program.free_shipping": "Kostenloser Versand",
    "membership_program.free_shipping_desc":
      "Kostenloser Versandgutschein, der für alle Bestellungen für ein Jahr ab Kauf des Plans gilt.",
    "membership_program.percentage_automatic_discount": "Prozentrabatt",
    "membership_program.percentage_automatic_discount_desc":
      "{value}% Rabatt automatisch auf alle Bestellungen für ein Jahr nach dem Kauf des Plans angewendet.",
    "membership_program.free_shipping_automatic_discount":
      "Kostenloser Versand",
    "membership_program.free_shipping_automatic_discount_desc":
      "Kostenloser Versandgutschein automatisch auf alle Bestellungen für ein Jahr nach dem Kauf des Plans angewendet.",
    "membership_program.active_plan": "Aktiver Plan",
    "membership_program.no_plan_benefits": "Keine Vorteile hinzugefügt",
    // limited time offer
    "main.limited_time_offer_program_title":
      "Programm für zeitlich begrenzte Angebote",
    "main.limited_time_offer_program_desc":
      "Greifen Sie auf exklusive Belohnungen mit unseren zeitlich begrenzten Angeboten zu, bevor sie verschwinden.",
    "earn.order_limit_note_lifetime":
      "Erhalten Sie {points_currency} auf den ersten {value} Bestellungen",
    "earn.order_limit_note":
      "Erhalten Sie {points_currency} auf den ersten {value1} Bestellungen alle {value2} Tag(e)",
    "earn.share_limit_note_lifetime":
      "Erhalten Sie {points_currency} auf den ersten {value} Shares",
    "earn.share_limit_note": "Teilen Sie {value1} Mal alle {value2} Tag(e)",
  },
  ch: {
    "main.title": "欢迎来到",
    "main.your_rewards": "你的奖励",
    "main.become_member_title": "成为会员",
    "main.become_member_desc":
      "通过更多方式解锁激动人心的福利，这是您获得独家奖励的所有通行证。",
    "main.join_now": "现在加入",
    "main.points_title": "积分",
    "main.points_desc":
      "通过不同的行动赚取更多积分，并将这些积分转化为超棒的奖励！",
    "main.ways_to_earn": "赚钱方式",
    "main.ways_to_redeem": "兑换方式",
    "main.referrals_title": "推荐",
    "main.referrals_desc":
      "给你的朋友一个奖励，并在他们购买时领取你自己的奖励。",
    "main.referrals_button": "推荐你的朋友",
    "main.your_points": "你的积分",
    "earn.title": "赚取方式",
    "earn.sign_up": "注册",
    "earn.birth_day": "庆祝生日",
    "earn.order_title": "下订单",
    "earn.order_desc":
      "{value} {points_currency} 对应每一个使用的 {currency} {amount_spent}",
    "earn.fb_like": "在 Facebook 上点赞",
    "earn.fb_share": "在 Facebook 上分享",
    "earn.insta_follow": "在 Instagram 上关注",
    "earn.twitter_share": "在推特上分享",
    "earn.twitter_follow": "在推特上关注",
    "earn.edit_date": "编辑日期",
    "redeem.title": "赎回方式",
    "redeem.fixed_coupon": "{currency} {value} 优惠券",
    "redeem.percentage_coupon": "{value} % 优惠券",
    "redeem.shipping": "免运费优惠券",
    "redeem.redeem_button": "赎回",
    "rewards.fixed_coupon": "{currency} {value} off",
    "rewards.no_rewards": "还没有奖励",
    "rewards.percentage_coupon": "{value} % off",
    "rewards.shipping": "免运费",
    "rewards.your_coupons": "你的优惠券",
    "birthday.title": "生日奖励",
    "birthday.desc":
      "我们想庆祝你的生日！确保您至少提前 30 天通知我们——否则，您将不得不等到明年。",
    "birthday.select_title": "选择你的生日",
    "birthday.save_date": "保存日期",
    "discount.title": "优惠码",
    "discount.spent_points": "花费了 {value} 点",
    "discount.desc": "在您的下一个订单中使用此折扣代码！",
    "footer.title": "我们奖励超级奖励。",
    //new tags after update
    "main.already_have_account": "已有账号？",
    "charity.title": "慈善积分",
    "charity.donate": "捐赠积分给你最喜欢的慈善机构！",
    "charity.title_ways": "捐赠方式",
    "charity.donating": "你在捐赠",
    "referral.they_get": "他们得到",
    "referral.you_get": "你得到",
    "rewards.available": "您有 {value} 个可用的奖励",
    "subscribe.products": "订阅产品",
    "subscribe.list": "所有订阅列表",
    "subscribe.points": "订阅积分",
    "rewards.free_product": "免费产品",
    "rewards.list_of_products": "所有产品列表",
    "main.refferral_completed": "推荐完成",
    "main.referrals_desc_loggedin":
      "分享这个 URL 给你的朋友奖励 {currency} {value} 优惠券",
    "main.view": "视图",
    "referral.code": "您的推荐代码",
    "rewards.see_here": "兑换奖励时，您会在这里看到它们",
    "rewards.go_back": "返回",

    "discount.off": "off",
    "discount.points_spent": "花费的积分",
    "discount.coupon_valid": "优惠券适用于",
    "discount.for": "为了",
    "discount.apply_code": "申请代码",
    "discount.coupon_title": "折扣券",
    "discount.expiry_date": "到期日期",
    "giftcard.balance": "余额",
    "giftcard.title_gift": "礼物",
    "giftcard.title_card": "卡片",
    "giftcard.copy_code": "复制代码",
    "giftcard.copied": "已复制",

    "earn.giftcard_order_desc": "{value} 每消费 {value2} 的礼品卡",
    "birthday.close": "关闭",
    "rewards.view_all": "查看所有奖励",
    "rewards.view_less": "查看更少的奖励",
    //
    "main.vip_tier_title": "VIP 等级",
    "main.become_vip_member": "成为VIP会员",
    "main.become_vip_member_desc":
      "您的所有访问通行证都可以获得独家奖励。达到更高级别以获得更多独家特权。",
    "main.current_tier": "当前层",
    "main.current_tier_desc": "你的所有权限都可以获得独家奖励。",
    "main.current_tier_btn": "查看所有层",
    "main.vip_you_have_to": "你必须",
    "main.vip_place_order": "下订单",
    "main.vip_atleast": "至少",
    "main.vip_more_than": "超过",
    "main.vip_less_than": "小于",
    "main.vip_time": "时间",
    "main.vip_spent": "花费",
    "main.on_your_store": "在我们的商店",
    "vip_tier.percentage_discount_title": "百分比折扣",
    "vip_tier.percentage_discount_desc": "自动应用 {value}% 折扣到所有订单。",
    "vip_tier.free_shipping_title": "免费送货",
    "vip_tier.free_shipping_desc": "自动应用免费送货到所有订单。",

    "earn.write_review": "写评论",
    "earn.leave_google_review": "离开谷歌评论",
    "reward.for_all_orders": "所有订单",
    "reward.collection": "收藏",
    "vip_tier.rules": "规则",
    "vip_tier.special_reward": "特别奖励",
    "main.join": "现在免费加入开始赚钱",
    "earn.follow_tiktok": "关注 TikTok",
    "earn.follow_linkedin": "在 LinkedIn 上关注",
    "earn.connect_line": "在 Line 上连接",
    // membership program
    "main.membership_program_title": "会员计划",
    "main.membership_program_desc":
      "使用我们的高级会员计划解锁通往独家奖励的大门。",
    "main.membership_program_note": "计划在购买后 1 年到期。",
    "main.no_membership_plans": "未添加会员计划",
    "membership_program.loyalty_multiplier": "忠诚度倍增器",
    "membership_program.bonus_points": "奖励积分",
    "membership_program.bonus_points_desc":
      "购买计划时获得 {value} {points_currency}",
    "membership_program.bonus_giftcard": "额外礼品卡",
    "membership_program.bonus_giftcard_desc":
      "购买计划时价值 {value} 的礼品卡信用",
    "membership_program.percentage_discount_coupon": "百分比折扣券",
    "membership_program.percentage_discount_coupon_desc":
      "购买该计划后一年内适用于所有订单的{value}%折扣券。",
    "membership_program.free_shipping": "免费送货",
    "membership_program.free_shipping_desc":
      "购买该计划后一年内适用于所有订单的免费送货券。",
    "membership_program.percentage_automatic_discount": "百分比折扣",
    "membership_program.percentage_automatic_discount_desc":
      "购买该计划后一年内适用于所有订单的{value}%折扣。",
    "membership_program.free_shipping_automatic_discount": "免费送货",
    "membership_program.free_shipping_automatic_discount_desc":
      "购买该计划后一年内适用于所有订单的免费送货券。",
    "membership_program.active_plan": "活跃计划",
    "membership_program.no_plan_benefits": "没有添加任何福利",
    // limited time offer
    "main.limited_time_offer_program_title": "限时优惠计划",
    "main.limited_time_offer_program_desc":
      "在它们消失之前，利用我们的限时优惠获得独家奖励。",
    "earn.order_limit_note_lifetime":
      "在前 {value} 个订单上获得 {points_currency}",
    "earn.order_limit_note":
      "每 {value2} 天在前 {value1} 个订单上获得 {points_currency}",
    "earn.share_limit_note_lifetime":
      "在前 {value} 个行动上获得 {points_currency}",
    "earn.share_limit_note": "每 {value2} 天分享 {value1} 次",
  },
  // hebrew
  hb: {
    "main.title": "ברוך הבא ל",
    "main.your_rewards": "הפרסים שלך",
    "main.become_member_title": "הפוך לחבר",
    "main.become_member_desc":
      "עם עוד דרכים לפתוח הטבות מרגשות, זהו כרטיס הגישה שלך לכל פרסים בלעדיים.",
    "main.join_now": "הצטרף עכשיו",
    "main.points_title": "נקודות",
    "main.points_desc":
      "הרוויח יותר נקודות עבור פעולות שונות, והפוך את הנקודות האלה לתגמולים מדהימים!",
    "main.ways_to_earn": "דרכים להרוויח",
    "main.ways_to_redeem": "דרכים לפדות",
    "main.referrals_title": "הפניות",
    "main.referrals_desc":
      "תן פרס לחברים שלך ותבע את שלך כאשר הם מבצעים רכישה.",
    "main.referrals_button": "הפנה את החברים שלך",
    "main.your_points": "הנקודות שלך",
    "earn.title": "דרכים להרוויח",
    "earn.sign_up": "הירשם",
    "earn.birth_day": "חוגגים יום הולדת",
    "earn.edit_date": "ערוך תאריך",
    "earn.order_title": "הזמנה",
    "earn.order_desc":
      "{value} {points_currency} עבור כל {currency} {amount_spent} בשימוש",
    "earn.fb_like": "לעשות לייק בפייסבוק",
    "earn.fb_share": "שתף בפייסבוק",
    "earn.insta_follow": "עקוב אחר באינסטגרם",
    "earn.twitter_share": "שתף בטוויטר",
    "earn.twitter_follow": "עקוב בטוויטר",
    "redeem.title": "שתף בטוויטר",
    "redeem.redeem_button": "לִפְדוֹת",
    "redeem.fixed_coupon": "קופון {currency} {value} הנחה",
    "redeem.percentage_coupon": "קופון של {value} % הנחה",
    "redeem.shipping": "קופון משלוח חינם",

    "rewards.fixed_coupon": "הנחה של {currency} {value}",

    "rewards.no_rewards": "עדיין אין פרסים",

    "rewards.percentage_coupon": "הנחה של {value} %",

    "rewards.shipping": "משלוח חינם",

    "rewards.your_coupons": "הקופונים שלך",
    "birthday.title": "תגמול יום הולדת",

    "birthday.desc":
      "אנחנו רוצים לחגוג את יום ההולדת שלך! הקפד ליידע אותנו לפחות 30 יום מראש - אחרת תצטרך לחכות לשנה הבאה.",
    "birthday.select_title": "בחר את יום ההולדת שלך",
    "birthday.save_date": "שמור תאריך",
    "discount.title": "קוד הנחה",
    "discount.spent_points": "הוציאו נקודות {value}",
    "discount.desc": "השתמש בקוד הנחה זה בהזמנה הבאה שלך!",
    "footer.title": "אנו מתגמלים עם Super Rewards.",
    //new tags after update
    "main.already_have_account": "כבר יש לך חשבון?",
    "charity.title": "נקודות צדקה",
    "charity.donate": "תרום נקודות לצדקה האהובה עליך!",
    "charity.title_ways": "דרכים לתרום",
    "charity.donating": "אתה תורם",
    "referral.they_get": "הם מקבלים",
    "referral.you_get": "אתה מקבל",
    "rewards.available": "יש לך {value} תגמולים זמינים",
    "subscribe.products": "הירשם למוצרים",
    "subscribe.list": "רשימת כל המינויים",
    "subscribe.points": "נקודות מנויים",
    "rewards.free_product": "מוצר בחינם",
    "rewards.list_of_products": "רשימת כל המוצרים",
    "main.refferral_completed": "הפניות הושלמו",
    "main.referrals_desc_loggedin":
      "שתף את כתובת האתר הזו כדי לתת לחבריך את קופון ההנחה של {currency} {value}",
    "main.view": "הצג",
    "referral.code": "קוד ההפניה שלך",
    "rewards.see_here": "כשתממש את התגמולים שלך, תראה אותם כאן",
    "rewards.go_back": "חזור",

    "discount.off": "off",
    "discount.points_spent": "נקודות שהוצאו",
    "discount.coupon_valid": "הקופון תקף ל",
    "discount.for": "עבור",
    "discount.apply_code": "החל קוד",
    "discount.coupon_title": "קופון הנחה",
    "discount.expiry_date": "תאריך תפוגה",
    "giftcard.balance": "יתרה",
    "giftcard.title_gift": "מתנה",
    "giftcard.title_card": "כרטיס",
    "giftcard.copy_code": "העתק קוד",
    "giftcard.copied": "הועתק",

    "earn.giftcard_order_desc": "כרטיס מתנה של {value} על כל {value2} שהוצא",
    "birthday.close": "סגור",
    "rewards.view_all": "הצג את כל התגמולים",
    "rewards.view_less": "הצג פחות תגמולים",
    //
    "main.vip_tier_title": "שכבות VIP",
    "main.become_vip_member": "הפוך לחבר VIP",
    "main.become_vip_member_desc":
      "הגישה המלאה שלך עוברת לתגמולים בלעדיים. הגיע לשכבות גבוהות יותר כדי לקבל הטבות בלעדיות יותר.",
    "main.current_tier": "שכבה נוכחית",
    "main.current_tier_desc": "כל הגישה שלך עובר לתגמולים בלעדיים.",
    "main.current_tier_btn": "הצג את כל השכבות",
    "main.vip_you_have_to": "אתה חייב",
    "main.vip_place_order": "בצע הזמנה",
    "main.vip_atleast": "לפחות",
    "main.vip_more_than": "יותר מ",
    "main.vip_less_than": "פחות מ",
    "main.vip_time": "זמן",
    "main.vip_spent": "בזבז",
    "main.on_your_store": "בחנות שלנו",
    "vip_tier.percentage_discount_title": "Percentage Discount",
    "vip_tier.percentage_discount_desc":
      "Automatically apply a {value}% discount to all orders.",
    "vip_tier.free_shipping_title": "Free Shipping",
    "vip_tier.free_shipping_desc":
      "Automatically apply free shipping to all orders.",

    "earn.write_review": "כתוב ביקורת",
    "earn.leave_google_review": "עזוב את סקירת Google",
    "reward.for_all_orders": "לכל ההזמנות",
    "reward.collection": "אוסף",
    "vip_tier.rules": "כללים",
    "vip_tier.special_reward": "תגמול מיוחד",
    "main.join": "הצטרף עכשיו בחינם כדי להתחיל להרוויח",
    "earn.follow_tiktok": "עקוב אחרי TikTok",
    "earn.follow_linkedin": "עקוב בלינקדאין",
    "earn.connect_line": "התחבר ב־Line",
    // membership program
    "main.membership_program_title": "תוכנית חברות",
    "main.membership_program_desc":
      "פתח את השער שלך לפרסים בלעדיים עם תוכניות החברות הפרימיום שלנו.",
    "main.membership_program_note": "התוכנית תפוג 1 שנה לאחר הרכישה.",
    "main.no_membership_plans": "לא נוספו תוכניות חברות",
    "membership_program.loyalty_multiplier": "מכפלת נאמנות",
    "membership_program.bonus_points": "נקודות בונוס",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} ברכישת התוכנית",
    "membership_program.bonus_giftcard": "כרטיס מתנה בונוס",
    "membership_program.bonus_giftcard_desc":
      "{value} בשווי כרטיס מתנה ברכישת התוכנית",
    "membership_program.percentage_discount_coupon": "קופון הנחה באחוזים",
    "membership_program.percentage_discount_coupon_desc":
      "קופון הנחה של {value}% החל על כל ההזמנות לשנה לאחר רכישת התוכנית.",
    "membership_program.free_shipping": "משלוח חינם",
    "membership_program.free_shipping_desc":
      "קופון משלוח חינם החל על כל ההזמנות לשנה לאחר רכישת התוכנית.",
    "membership_program.percentage_automatic_discount": "קופון הנחה באחוזים",
    "membership_program.percentage_automatic_discount_desc":
      "קופון הנחה של {value}% החל על כל ההזמנות לשנה לאחר רכישת התוכנית.",
    "membership_program.free_shipping_automatic_discount": "משלוח חינם",
    "membership_program.free_shipping_automatic_discount_desc":
      "קופון משלוח חינם החל על כל ההזמנות לשנה לאחר רכישת התוכנית.",
    "membership_program.active_plan": "תוכנית פעילה",
    "membership_program.no_plan_benefits": "אין יתרונות שנוספו",
    // limited time offer
    "main.limited_time_offer_program_title": "תוכנית הצעה לזמן מוגבל",
    "main.limited_time_offer_program_desc":
      "גישה לפרסים בלעדיים עם ההצעות המוגבלות בזמן שלנו לפני שהן נעלמות.",
    "earn.order_limit_note_lifetime":
      "קבל {points_currency} על ההזמנות הראשונות {value}",
    "earn.order_limit_note":
      "קבל {points_currency} על ההזמנות הראשונות {value1} כל {value2} יום",
    "earn.share_limit_note_lifetime":
      "קבל {points_currency} על השיתופים הראשונים {value}",
    "earn.share_limit_note": "שתף {value1} פעמים כל {value2} יום",
  },
  // norweign language
  norsk: {
    "main.title": "Velkommen til",
    "main.your_rewards": "Dine belønninger",
    "main.become_member_title": "Bli medlem",
    "main.become_member_desc":
      "Med flere måter å låse opp spennende fordeler på, er dette ditt all tilgangspass til eksklusive belønninger.",
    "main.join_now": "Bli med nå",
    "main.points_title": "Poeng",
    "main.points_desc":
      "tjen flere poeng for forskjellige handlinger, og gjør disse poengene til fantastiske belønninger!",
    "main.ways_to_earn": "Måter å tjene på",
    "main.ways_to_redeem": "Måter å løse inn",
    "main.referrals_title": "Henvisninger",
    "main.referrals_desc":
      "Gi vennene dine en belønning og krev din egen når de foretar et kjøp.",
    "main.referrals_button": "Verv vennene dine",
    "main.your_points": "Dine poeng",
    "earn.title": "Måter å tjene på",
    "earn.sign_up": "Registrering",
    "earn.birth_day": "Feir en bursdag",
    "earn.edit_date": "Rediger dato",
    "earn.order_title": "Legg inn en bestilling",
    "earn.order_desc":
      "{value} {points_currency} for hver {currency}{amount_spent} brukt",
    "earn.fb_like": "Liker på Facebook",
    "earn.fb_share": "Del på Facebook",
    "earn.insta_follow": "Følg på Instagram",
    "earn.twitter_share": "Del på Twitter",
    "earn.twitter_follow": "Følg på Twitter",
    "redeem.title": "Måter å løse inn",
    "redeem.redeem_button": "Løs inn",
    "redeem.fixed_coupon": "{currency} {value} rabattkupong",
    "redeem.percentage_coupon": "{value} % rabattkupong",
    "redeem.shipping": "Gratis fraktkupong",
    "rewards.fixed_coupon": "{currency} {value} rabatt",
    "rewards.no_rewards": "Ingen belønninger ennå",
    "rewards.percentage_coupon": "{value} % rabatt",
    "rewards.shipping": "Gratis frakt",
    "rewards.your_coupons": "Dine kuponger",
    "birthday.title": "Bursdagsbelønning",
    "bursdag.desc":
      "Vi ønsker å feire bursdagen din! Sørg for at du gir oss beskjed minst 30 dager i forveien - ellers må du vente til neste år.",
    "birthday.select_title": "Velg bursdagen din",
    "birthday.save_date": "Lagre dato",
    "discount.title": "Rabattkode",
    "discount.spent_points": "Brukt {value} poeng",
    "discount.desc": "Bruk denne rabattkoden på din neste bestilling!",
    "footer.title": "Vi belønner med superbelønninger.",
    //new tags after update
    "main.already_have_account": "Har du allerede en konto?",
    "charity.title": "Veldeenhetspoeng",
    "charity.donate": "Doner poeng til din favoritt veldedighet!",
    "charity.title_ways": "Måter å donere",
    "charity.donating": "Du donerer",
    "referral.they_get": "De får",
    "referral.you_get": "Du får",
    "rewards.available": "Du har {value} belønninger tilgjengelig",
    "subscribe.products": "Abonner på produkter",
    "subscribe.list": "Liste over alle abonnementer",
    "subscribe.points": "Abonnementspoeng",
    "rewards.free_product": "Gratis produkt",
    "rewards.list_of_products": "Liste over alle produkter",
    "main.refferral_completed": "henvisninger fullført",
    "main.referrals_desc_loggedin":
      "Del denne nettadressen for å gi vennene dine rabattkupongen {currency} {value}",
    "main.view": "Vis",
    "referral.code": "Din henvisningskode",
    "rewards.see_here": "Når du løser inn belønningene dine, vil du se dem her",
    "rewards.go_back": "Gå tilbake",

    "discount.off": "av",
    "discount.points_spent": "Poeng brukt",
    "discount.coupon_valid": "Kupongen er gyldig for",
    "discount.for": "for",
    "discount.apply_code": "Bruk kode",
    "discount.coupon_title": "Rabattkupong",
    "discount.expiry_date": "Utløpsdato",
    "giftcard.balance": "Saldo",
    "giftcard.title_gift": "Gave",
    "giftcard.title_card": "Kort",
    "giftcard.copy_code": "Kopiér kode",
    "giftcard.copied": "Kopiert",

    "earn.giftcard_order_desc": "{value} gavekort for hver {value2} brukt",
    "birthday.close": "Lukk",
    "rewards.view_all": "Se alle belønninger",
    "rewards.view_less": "Se færre belønninger",
    //
    "main.vip_tier_title": "VIP-nivåer",
    "main.become_vip_member": "Bli VIP-medlem",
    "main.become_vip_member_desc":
      "All tilgangskortet ditt til eksklusive belønninger. Nå høyere nivåer for flere eksklusive fordeler.",
    "main.current_tier": "Gjeldende nivå",
    "main.current_tier_desc":
      "All tilgangspasset ditt til eksklusive belønninger.",
    "main.current_tier_btn": "Se alle nivåer",
    "main.vip_you_have_to": "Du må",
    "main.vip_place_order": "legg inn bestilling",
    "main.vip_atleast": "minst",
    "main.vip_more_than": "mer enn",
    "main.vip_less_than": "mindre enn",
    "main.vip_time": "tid",
    "main.vip_spent": "brukt",
    "main.on_your_store": "på vår butikk",
    "vip_tier.percentage_discount_title": "Prosentrabatt",
    "vip_tier.percentage_discount_desc":
      "Automatisk {value}% Rabatt på alle bestillinger.",
    "vip_tier.free_shipping_title": "Gratis frakt",
    "vip_tier.free_shipping_desc":
      "Automatisk gratis frakt på alle bestillinger.",

    "earn.write_review": "Skriv en anmeldelse",
    "earn.leave_google_review": "Forlat Google-anmeldelse",
    "reward.for_all_orders": "For alle bestillinger",
    "reward.collection": "samling",
    "vip_tier.rules": "Regler",
    "vip_tier.special_reward": "Spesiell belønning",
    "main.join": "Bli med nå gratis for å begynne å tjene",
    "earn.follow_tiktok": "Følg på TikTok",
    "earn.follow_linkedin": "Følg på LinkedIn",
    "earn.connect_line": "Koble til på Line",
    // membership program
    "main.membership_program_title": "Medlemsprogram",
    "main.membership_program_desc":
      "Lås opp porten til eksklusive belønninger med våre premium medlemskap.",
    "main.membership_program_note": "Planen utløper 1 år etter kjøpet.",
    "main.no_membership_plans": "Ingen medlemskapsplaner lagt til",
    "membership_program.loyalty_multiplier": "Lojalitetsmultiplikator",
    "membership_program.bonus_points": "Bonuspoeng",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} ved kjøp av planen",
    "membership_program.bonus_giftcard": "Bonus gavekort",
    "membership_program.bonus_giftcard_desc":
      "{value} verdi av gavekortkreditt ved kjøp av planen",
    "membership_program.percentage_discount_coupon": "Prosentrabattkupong",
    "membership_program.percentage_discount_coupon_desc":
      "{value}% rabattkupong som gjelder for alle bestillinger i ett år etter kjøp av planen.",
    "membership_program.free_shipping": "Gratis frakt",
    "membership_program.free_shipping_desc":
      "Gratis fraktkupong som gjelder for alle bestillinger i ett år etter kjøp av planen.",
    "membership_program.percentage_automatic_discount": "Prosentrabatt",
    "membership_program.percentage_automatic_discount_desc":
      "Prosentrabatt automatisk anvendt på alle bestillinger i ett år etter kjøp av planen.",
    "membership_program.free_shipping_automatic_discount": "Gratis frakt",
    "membership_program.free_shipping_automatic_discount_desc":
      "Gratis fraktkupong automatisk anvendt på alle bestillinger i ett år etter kjøp av planen.",
    "membership_program.active_plan": "Aktivt plan",
    "membership_program.no_plan_benefits": "Ingen fordeler lagt til",
    // limited time offer
    "main.limited_time_offer_program_title": "Tidsbegrenset tilbud program",
    "main.limited_time_offer_program_desc":
      "Få tilgang til eksklusive belønninger med våre tidsbegrensede tilbud før de forsvinner.",
    "earn.order_limit_note_lifetime":
      "Få {points_currency} på de første {value} bestillingene",
    "earn.order_limit_note":
      "Få {points_currency} på de første {value1} hver {value2} dager",
    "earn.share_limit_note_lifetime":
      "Få {points_currency} på de første {value} handlingene",
    "earn.share_limit_note": "Del {value1} ganger hver {value2} dager",
  },

  dan: {
    "main.title": "Velkommen til",
    "main.your_rewards": "Dine belønninger",
    "main.become_member_title": "Bliv medlem",
    "main.become_member_desc":
      "Med flere måder at låse op for spændende frynsegoder på, er dette dit pas med fuld adgang til eksklusive belønninger.",
    "main.join_now": "Tilmeld dig nu",
    "main.points_title": "Points",
    "main.points_desc":
      "Tjen flere point for forskellige handlinger, og forvandl disse point til fantastiske belønninger!",
    "main.ways_to_earn": "Måder at tjene på",
    "main.ways_to_redeem": "Måder at indløse",
    "main.referrals_title": "Henvisninger",
    "main.referrals_desc":
      "Giv dine venner en belønning og kræve din egen, når de foretager et køb.",
    "main.referrals_button": "Henvis dine venner",
    "main.your_points": "Dine point",
    "earn.title": "Måder at tjene på",
    "earn.sign_up": "Tilmelding",
    "earn.birth_day": "Fejre en fødselsdag",
    "earn.edit_date": "Rediger dato",
    "earn.order_title": "Afgiv en ordre",
    "earn.order_desc":
      "{value} {points_currency} for hver {currency}{amount_spent} brugt",
    "earn.fb_like": "Synes godt om på Facebook",
    "earn.fb_share": "Del på Facebook",
    "earn.insta_follow": "Følg på Instagram",
    "earn.twitter_share": "Del på Twitter",
    "earn.twitter_follow": "Følg på Twitter",
    "redeem.title": "Måder at indløse",
    "redeem.redeem_button": "Indløs",
    "redeem.fixed_coupon": "{currency} {value} rabatkupon",
    "redeem.percentage_coupon": "{value} % rabat på kupon",
    "redeem.shipping": "Gratis forsendelseskupon",
    "rewards.fixed_coupon": "{currency} {value} i rabat",
    "rewards.no_rewards": "Ingen belønninger endnu",
    "rewards.percentage_coupon": "{value} % rabat",
    "rewards.shipping": "Gratis forsendelse",
    "rewards.your_coupons": "Dine kuponer",
    "birthday.title": "Fødselsdagsbelønning",
    "birthday.desc":
      "Vi vil gerne fejre din fødselsdag! Sørg for at give os besked mindst 30 dage i forvejen - ellers må du vente til næste år.",
    "birthday.select_title": "Vælg din fødselsdag",
    "birthday.save_date": "Gem dato",
    "discount.title": "Rabatkode",
    "discount.spent_points": "Brugte {value} point",
    "discount.desc": "Brug denne rabatkode på din næste ordre!",
    "footer.title": "Vi belønner med superbelønninger.",
    //nye tags efter opdatering
    "main.already_have_account": "Har du allerede en konto?",
    "charity.title": "Velgørenhedspoint",
    "charity.donate": "Doner point til din yndlingsvelgørenhed!",
    "charity.title_ways": "Måder at donere",
    "charity.donating": "Du donerer",
    "referral.they_get": "De får",
    "referral.you_get": "Du får",
    "rewards.available": "Du har {value} tilgængelige belønninger",
    "subscribe.products": "Abonner på produkter",
    "subscribe.list": "Liste over alle abonnementer",
    "subscribe.points": "Abonnementspoint",
    "rewards.free_product": "Gratis produkt",
    "rewards.list_of_products": "Liste over alle produkter",
    "main.refferral_completed": "henvisninger gennemført",
    "main.referrals_desc_loggedin":
      "Del denne webadresse for at give dine venner belønningen {currency} {value} rabatkupon",
    "main.view": "Visning",
    "referral.code": "Din henvisningskode",
    "rewards.see_here": "Når du indløser dine belønninger, vil du se dem her",
    "rewards.go_back": "Gå tilbage",

    "discount.off": "fra",
    "discount.points_spent": "Punkt brugt",
    "discount.coupon_valid": "Kupon gyldig for",
    "discount.for": "for",
    "discount.apply_code": "Anvend kode",
    "discount.coupon_title": "Rabatkupon",
    "discount.expiry_date": "Udløbsdato",
    "giftcard.balance": "Saldo",
    "giftcard.title_gift": "Gave",
    "giftcard.title_card": "Kort",
    "giftcard.copy_code": "Kopiér kode",
    "giftcard.copied": "Kopieret",

    "earn.giftcard_order_desc": "{value} gavekort for hver {value2} brugt",
    "birthday.close": "Luk",
    "rewards.view_all": "Se alle belønninger",
    "rewards.view_less": "Se færre belønninger",
    //
    "main.vip_tier_title": "VIP-niveauer",
    "main.become_vip_member": "Bliv VIP-medlem",
    "main.become_vip_member_desc":
      "Din adgangskode til eksklusive belønninger. Nå højere niveauer for mere eksklusive frynsegoder.",
    "main.current_tier": "Nuværende niveau",
    "main.current_tier_desc": "Dit adgangskort til eksklusive belønninger.",
    "main.current_tier_btn": "Se alle niveauer",
    "main.vip_you_have_to": "Det skal du",
    "main.vip_place_order": "afgiv ordre",
    "main.vip_atleast": "mindst",
    "main.vip_more_than": "mere end",
    "main.vip_less_than": "mindre end",
    "main.vip_time": "tid",
    "main.vip_spent": "brugt",
    "main.on_your_store": "i vores butik",
    "vip_tier.percentage_discount_title": "Procentrabatt",
    "vip_tier.percentage_discount_desc":
      "Automatisk {value}% Rabatt på alle bestillinger.",
    "vip_tier.free_shipping_title": "Gratis frakt",
    "vip_tier.free_shipping_desc":
      "Automatisk gratis frakt på alle bestillinger.",

    "earn.write_review": "Skriv en anmeldelse",
    "earn.leave_google_review": "Forlad Google-anmeldelse",
    "reward.for_all_orders": "For alle ordrer",
    "reward.collection": "samling",
    "vip_tier.rules": "Regler",
    "vip_tier.special_reward": "Særlig belønning",
    "main.join": "Tilmeld dig gratis nu for at begynde at tjene",
    "earn.follow_tiktok": "Følg på TikTok",
    "earn.follow_linkedin": "Følg på LinkedIn",
    "earn.connect_line": "Forbind på Line",
    // membership program
    "main.membership_program_title": "Medlemskabsprogram",
    "main.membership_program_desc":
      "Lås op for din adgang til eksklusive belønninger med vores premium medlemskabsplaner.",
    "main.membership_program_note": "Planen udløber 1 år efter købet.",
    "main.no_membership_plans": "Ingen medlemskabsplaner tilføjet",
    "membership_program.loyalty_multiplier": "Loyalitetsmultiplikator",
    "membership_program.bonus_points": "Bonuspoint",
    "membership_program.bonus_points_desc":
      "{value} {points_currency} ved køb af planen",
    "membership_program.bonus_giftcard": "Bonusgavekort",
    "membership_program.bonus_giftcard_desc":
      "{value} i gavekortskredit ved køb af planen",
    "membership_program.percentage_discount_coupon": "Procentrabat-kupon",
    "membership_program.percentage_discount_coupon_desc":
      "{value}% rabatkupon gældende for alle ordrer i et år efter køb af planen.",
    "membership_program.free_shipping": "Gratis fragt",
    "membership_program.free_shipping_desc":
      "Gratis fragtkupon gældende for alle ordrer i et år efter køb af planen.",
    "membership_program.free_shipping_automatic_discount": "Gratis fragt",
    "membership_program.free_shipping_automatic_discount_desc":
      "Gratis fragtkupon automatisk anvendt på alle bestillinger i ett år etter kjøp af planen.",
    "membership_program.percentage_automatic_discount": "Procentrabat",
    "membership_program.percentage_automatic_discount_desc":
      "Procentrabatt automatisk anvendt på alle bestillinger i ett år etter kjøp af planen.",
    "membership_program.active_plan": "Aktivt plan",
    "membership_program.no_plan_benefits": "Ingen fordele tilføjet",
    // limited time offer
    "main.limited_time_offer_program_title": "Program for begrænsede tilbud",
    "main.limited_time_offer_program_desc":
      "Få adgang til eksklusive belønninger med vores begrænsede tilbud, før de forsvinder.",
    "earn.order_limit_note_lifetime":
      "Få {points_currency} på de første {value} ordrer",
    "earn.order_limit_note":
      "Få {points_currency} på de første {value1} hver {value2} dage",
    "earn.share_limit_note_lifetime":
      "Få {points_currency} på de første {value} handlinger",
    "earn.share_limit_note": "Del {value1} gange hver {value2} dage",
  },
  // japanese
  ja: {
    "main.title": "ようこそ",
    "main.your_rewards": "あなたの報酬",
    "main.become_member_title": "メンバーになる",
    "main.become_member_desc":
      "エキサイティングな特典のロックを解除する方法が増えたので、これが限定特典へのすべてのアクセスパスになります。",
    "main.join_now": "今すぐ参加",
    "main.points_title": "ポイント",
    "main.points_desc":
      "さまざまなアクションでより多くのポイントを獲得し、それらのポイントを素晴らしい報酬に変えましょう！",
    "main.ways_to_earn": "稼ぐ方法",
    "main.ways_to_redeem": "利用方法",
    "main.referrals_title": "紹介",
    "main.referrals_desc":
      "友達に報酬を与えて、彼らが購入するときにあなた自身のものを要求してください。",
    "main.referrals_button": "友達を紹介する",
    "main.your_points": "あなたのポイント",
    "earn.title": "稼ぐ方法",
    "earn.sign_up": "サインアップ",
    "earn.birth_day": "誕生日を祝う",
    "earn.edit_date": "編集日",
    "earn.order_title": "注文する",
    "earn.order_desc":
      "{currency}{amount_spent}が費やされるごとに{value}{points_currency}",
    "earn.fb_like": "Facebookのように",
    "earn.fb_share": "Facebookで共有",
    "earn.insta_follow": "Instagramでフォローする",
    "earn.twitter_share": "Twitterで共有",
    "earn.twitter_follow": "Twitterでフォロー",
    "redeem.title": "利用方法",
    "redeem.redeem_button": "償還",
    "redeem.fixed_coupon": "{currency} {value} オフクーポン",
    "redeem.percentage_coupon": "{value}％オフクーポン",
    "redeem.shipping": "送料無料クーポン",
    "rewards.fixed_coupon": "{currency} {value} オフ",
    "rewards.no_rewards": "まだ報酬はありません",
    "rewards.percentage_coupon": "{value}％オフ",
    "rewards.shipping": "送料無料",
    "rewards.your_coupons": "あなたのクーポン",
    "birthday.title": "誕生日の報酬",
    "birthday.desc":
      "私たちはあなたの誕生日を祝いたいです！少なくとも30日前に私たちに知らせてください-さもなければ、あなたは来年まで待たなければなりません。",
    "birthday.select_title": "誕生日を選択してください",
    "birthday.save_date": "保存日",
    "discount.title": "割引コード",
    "discount.spent_points": "使用済み{値}ポイント",
    "discount.desc": "次の注文でこの割引コードを使用してください！",
    "footer.title": "We Reward with Super Rewards。",
    "main.already_have_account": "すでにアカウントをお持ちですか？",
    "charity.title": "チャリティーポイント",
    "charity.donate": "寄付はお気に入りの慈善団体を指しています！",
    "charity.title_ways": "寄付の方法",
    "charity.donating": "あなたは寄付しています",
    "referral.they_get": "彼らは得る",
    "referral.you_get": "あなたが得る",
    "rewards.available": "{value}の特典を利用できます",
    "subscribe.products": "製品を購読する",
    "subscribe.list": "すべてのサブスクリプションのリスト",
    "subscribe.points": "サブスクリプションポイント",
    "rewards.free_product": "無料の製品",
    "rewards.list_of_products": "すべての製品のリスト",
    "main.refferral_completed": "紹介が完了しました",
    "main.referrals_desc_loggedin":
      "このURLを共有して、お友達にクーポンの{currency} {value}オフの報酬を提供してください",
    "main.view": "表示",
    "referral.code": "あなたの紹介コード",
    "rewards.see_here": "特典を利用すると、ここに表示されます",
    "rewards.go_back": "戻る",

    "discount.off": "オフ",
    "discount.points_spent": "消費ポイント",
    "discount.coupon_valid": "有効なクーポン",
    "discount.for": "にとって",
    "discount.apply_code": "コードを適用",
    "discount.coupon_title": "割引クーポン",
    "discount.expiry_date": "有効期限",
    "giftcard.balance": "バランス",
    "giftcard.title_gift": "ギフト",
    "giftcard.title_card": "カード",
    "giftcard.copy_code": "コードをコピー",
    "giftcard.copied": "コピー済み",

    "earn.giftcard_order_desc": "{value2}を使うごとに{value}ギフトカード",
    "birthday.close": "閉じる",
    "rewards.view_all": "すべての報酬を表示",
    "rewards.view_less": "表示する報酬が少ない",
    //vip層
    "main.vip_tier_title": "VIP層",
    "main.become_vip_member": "VIPメンバーになる",
    "main.become_vip_member_desc":
      "あなたのすべてのアクセスは排他的な報酬へのパスです。より排他的な特典のために、より高いティアに到達してください。",
    "main.current_tier": "現在の層",
    "main.current_tier_desc": "独占特典へのすべてのアクセスパス。",
    "main.current_tier_btn": "すべての層を表示",
    "main.vip_you_have_to": "あなたがしなければならない",
    "main.vip_place_order": "注文する",
    "main.vip_atleast": "at least",
    "main.vip_more_than": "以上",
    "main.vip_less_than": "未満",
    "main.vip_time": "time",
    "main.vip_spent": "spent",
    "main.on_your_store": "当店で",
    "vip_tier.percentage_discount_title": "割引クーポン（パーセンテージ）",
    "vip_tier.percentage_discount_desc":
      "プラン購入後1年間、すべての注文に適用される{value}%割引クーポン。",
    "vip_tier.free_shipping_title": "無料配送",
    "vip_tier.free_shipping_desc":
      "プラン購入後1年間、すべての注文に適用される無料配送クーポン。",
    // new
    "earn.write_review": "レビューを書く",
    "earn.leave_google_review": "Googleレビューを残す",
    "reward.for_all_orders": "すべての注文について",
    "reward.collection": "コレクション",
    "vip_tier.rules": "ルール",
    "vip_tier.special_reward": "特別報酬",
    "main.join": "今すぐ無料で参加して、収益を上げましょう",
    "main.join_text": "参加",
    "main.sign_in": "サインイン",
    "earn.follow_tiktok": "TikTok をフォロー",
    "earn.follow_linkedin": "LinkedIn をフォロー",
    "earn.connect_line": "Lineで接続",
    // membership program
    "main.membership_program_title": "メンバーシッププログラム",
    "main.membership_program_desc":
      "プレミアムメンバーシッププランで独占的な特典への扉を開けてください。",
    "main.membership_program_note": "プランは購入後1年で期限切れになります。",
    "main.no_membership_plans": "追加されたメンバーシッププランはありません",
    "membership_program.loyalty_multiplier": "ロイヤリティ乗数",
    "membership_program.bonus_points": "ボーナスポイント",
    "membership_program.bonus_points_desc":
      "プラン購入時に {value} {points_currency}",
    "membership_program.bonus_giftcard": "ボーナスギフトカード",
    "membership_program.bonus_giftcard_desc":
      "プラン購入時に {value} のギフトカードクレジット",
    "membership_program.percentage_discount_coupon":
      "割引クーポン（パーセンテージ）",
    "membership_program.percentage_discount_coupon_desc":
      "プラン購入後1年間、すべての注文に適用される{value}%割引クーポン。",
    "membership_program.free_shipping": "無料配送",
    "membership_program.free_shipping_desc":
      "プラン購入後1年間、すべての注文に適用される無料配送クーポン。",
    "membership_program.percentage_automatic_discount": "パーセンテージ割引",
    "membership_program.percentage_automatic_discount_desc":
      "プラン購入後1年間、すべての注文に適用される{value}%割引クーポン。",
    "membership_program.free_shipping_automatic_discount": "無料配送",
    "membership_program.free_shipping_automatic_discount_desc":
      "プラン購入後1年間、すべての注文に適用される無料配送クーポン。",
    "membership_program.active_plan": "アクティブプラン",
    "membership_program.no_plan_benefits": "特典なし",
    // limited time offer
    "main.limited_time_offer_program_title": "期間限定オファープログラム",
    "main.limited_time_offer_program_desc":
      "限定オファーが終了する前に、当社の限定オファーで独占的な特典にアクセスしてください。",
    "earn.order_limit_note_lifetime":
      "最初の {value} 注文に {points_currency} を獲得",
    "earn.order_limit_note":
      "{value2} ごとに {value1} 注文に {points_currency} を獲得",
    "earn.share_limit_note_lifetime":
      "最初の {value} アクションに {points_currency} を獲得",
    "earn.share_limit_note": "{value2} ごとに {value1} 回共有",
  },
};
